// Do not edit directly, this file was auto-generated.

export default {
  IDSmetadata: {
    exportTimestamp: 'Tue, 21 Apr 2026 23:52:20 GMT',
    figmaLastUpdated: 'Tue, 21 Apr 2026 23:27:32 GMT',
    format: 'javascript-esm-react',
    measurementUnits: 'px',
    relatedThemeName: 'none',
    styleDictionaryVersion: '4.4.0',
    targetPlatform: 'desktop',
    themeName: 'Patient Vanda Ponvory',
    tokensetVersion: '1.49.0',
    typographySetName: 'functionalTypography-VandaPonvory',
  },
  accordion: {
    default: {
      color: {
        body: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          text: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
        },
        decorative: {
          accent: '#00ccb6',
          decorative1: '#006cff',
          decorative2: '#ff9300',
          decorative3: '#cdda01',
          decorative4: '#00a3e0',
          decorative5: '#00bfb3',
          error: '#bd0100',
          neutral: '#575757',
          success: '#027815',
          warning: '#f4c65a',
        },
        divider: {
          disabled: 'rgba(232,232,232,0.48)',
          enabled: '#e8e8e8',
          focus: '#e8e8e8',
          hover: '#dddddd',
          pressed: '#c7c7c7',
        },
        expanded: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#edf2ef',
            pressed: '#e4ece7',
          },
        },
        header: {
          collapsed: {
            background: {
              disabled: 'rgba(245,248,246,0.48)',
              enabled: '#f5f8f6',
              focus: '#f5f8f6',
              hover: '#edf2ef',
              pressed: '#e4ece7',
            },
          },
          text: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
        },
        sublabel: {
          disabled: 'rgba(87,87,87,0.48)',
          enabled: '#575757',
          focus: '#575757',
          hover: '#444444',
          pressed: '#333333',
        },
      },
      radius: {
        body: '0',
        header: '0',
      },
      spacing: {
        expandCollapseAllGap: {
          groupGap: '16px',
        },
        small: {
          collapsed: {
            min: {
              height: '48px',
              width: '320px',
            },
            padding: {
              bottom: '8px',
              gap: '8px',
              left: '8px',
              right: '12px',
              top: '8px',
            },
          },
          expanded: {
            body: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '8px',
                gap: '24px',
                left: '36px',
                right: '12px',
                top: '4px',
              },
            },
            header: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '8px',
                gap: '8px',
                left: '8px',
                right: '12px',
                top: '8px',
              },
            },
            min: {
              height: '64px',
              width: '320px',
            },
          },
        },
        standard: {
          collapsed: {
            min: {
              height: '48px',
              width: '320px',
            },
            padding: {
              bottom: '12px',
              gap: '8px',
              left: '8px',
              right: '12px',
              top: '12px',
            },
          },
          expanded: {
            body: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '16px',
                gap: '24px',
                left: '36px',
                right: '12px',
                top: '8px',
              },
            },
            header: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '12px',
                gap: '8px',
                left: '8px',
                right: '12px',
                top: '12px',
              },
            },
            min: {
              height: '64px',
              width: '320px',
            },
          },
        },
      },
    },
  },
  autocomplete: {
    default: {
      padding: {
        small: {
          horizontalGap: '4px',
          verticalGap: '0',
        },
        standard: {
          horizontalGap: '4px',
          verticalGap: '4px',
        },
      },
    },
    error: {
      padding: {
        small: {
          horizontalGap: '4px',
          verticalGap: '0',
        },
        standard: {
          horizontalGap: '4px',
          verticalGap: '4px',
        },
      },
    },
  },
  avatar: {
    default: {
      color: {
        background: '#e8e8e8',
        border: {
          enabled: '#949494',
          focus: '#949494',
          hover: '#045d67',
          pressed: '#00403a',
        },
        content: '#3a3a3a',
        focusOutline: '#001a17',
        hover: 'rgba(0,0,0,0)',
        hoverOutline: '#045d67',
      },
      radius: '9999px',
      sizing: {
        large: '64px',
        medium: '48px',
        small: '40px',
        xl: '120px',
        xs: '24px',
      },
    },
  },
  badge: {
    default: {
      color: {
        background: {
          accent: '#00ccb6',
          brand: '#045d67',
          decorative1: '#006cff',
          decorative2: '#ff9300',
          decorative3: '#cdda01',
          decorative4: '#00a3e0',
          decorative5: '#00bfb3',
          default: {
            accent: '#00ccb6',
            brand: '#045d67',
            decorative1: '#006cff',
            decorative2: '#ff9300',
            decorative3: '#cdda01',
            decorative4: '#00a3e0',
            decorative5: '#00bfb3',
            neutral: '#3a3a3a',
          },
          dot: '#00ccb6',
          inverse: {
            accent: '#f0fffd',
            brand: '#e6fcfe',
            decorative1: '#e5f0ff',
            decorative2: '#fff4e5',
            decorative3: '#fdffe6',
            decorative4: '#e5f8ff',
            decorative5: '#e5fffd',
            neutral: '#ffffff',
            neutralInverse: '#ffffff',
          },
          neutral: '#ffffff',
          neutralInverse: '#3a3a3a',
          pill: '#00ccb6',
        },
        border: {
          default: '#030303',
          defaultInverse: '#ffffff',
        },
        label: {
          default: '#030303',
          defaultInverse: '#ffffff',
          pill: '#ffffff',
        },
      },
      radius: {
        dot: '9999px',
        pill: '9999px',
      },
      spacing: {
        standard: {
          min: {
            dotHeight: '20px',
            dotWidth: '20px',
            pillHeight: '20px',
            pillWidth: '20px',
          },
          padding: {
            bottom: '2px',
            left: '4px',
            right: '4px',
            top: '2px',
          },
        },
      },
    },
  },
  banner: {
    default: {
      color: {
        background: '#3a3a3a',
        icon: '#ffffff',
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: 'rgba(255,255,255,0.48)',
            text: 'rgba(255,255,255,0.48)',
          },
          enabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          focused: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          hover: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          outline: '#e6fcfe',
          pressed: {
            icon: '#ffffff',
            text: '#ffffff',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          text: '1200px',
        },
        min: {
          height: '48px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          icon: {
            bottom: '4px',
            gap: '0',
            left: '0',
            right: '0',
            top: '4px',
          },
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
    error: {
      color: {
        background: '#bd0100',
        icon: '#ffffff',
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: 'rgba(255,255,255,0.48)',
            text: 'rgba(255,255,255,0.48)',
          },
          enabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          focused: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          hover: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          outline: '#e6fcfe',
          pressed: {
            icon: '#ffffff',
            text: '#ffffff',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          text: '1200px',
        },
        min: {
          height: '48px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          icon: {
            bottom: '4px',
            gap: '0',
            left: '0',
            right: '0',
            top: '4px',
          },
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
    warning: {
      color: {
        background: '#926b00',
        icon: '#ffffff',
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: 'rgba(58,58,58,0.48)',
            text: 'rgba(58,58,58,0.48)',
          },
          enabled: {
            icon: '#3a3a3a',
            text: '#3a3a3a',
          },
          focused: {
            icon: '#3a3a3a',
            text: '#3a3a3a',
          },
          hover: {
            icon: '#242424',
            text: '#242424',
          },
          outline: '#001a17',
          pressed: {
            icon: '#030303',
            text: '#030303',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          text: '1200px',
        },
        min: {
          height: '48px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          icon: {
            bottom: '4px',
            gap: '0',
            left: '0',
            right: '0',
            top: '4px',
          },
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
  },
  blade: {
    default: {
      color: {
        border: {
          disabled: 'rgba(148,148,148,0.48)',
          enabled: '#949494',
          hover: '#00403a',
          iconButton: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
          },
          nonscrolling: {
            disabled: 'rgba(232,232,232,0.48)',
            enabled: '#c7c7c7',
            hover: '#00403a',
            pressed: '#002623',
          },
          pressed: '#002623',
          scrolling: {
            disabled: 'rgba(232,232,232,0.48)',
            enabled: '#c7c7c7',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
        borderDefault: '#949494',
        button: {
          enabled: '#045d67',
          focus: '#001a17',
          hover: '#00403a',
          pressed: '#002623',
        },
        container: {
          default: '#ffffff',
          enabled: 'rgba(4,93,103,0)',
          hover: 'rgba(4,93,103,0.08)',
          pressed: 'rgba(4,93,103,0.16)',
        },
        content: {
          copy: '#3a3a3a',
          label: '#3a3a3a',
          sublabel: '#3a3a3a',
        },
        copy: '#3a3a3a',
        label: '#3a3a3a',
        sublabel: '#3a3a3a',
      },
      sizing: {
        GapMedium: '8px',
        GapSmall: '8px',
        MaxWidthCollapsed: '40px',
        MinWidthExpanded: '320px',
        PaddingHorizontal: '24px',
        PaddingLabelsBottom: '2px',
        PaddingVertical: '16px',
      },
      spacing: {
        GapLarge: '24px',
        GapMedium: '16px',
        GapSmall: '8px',
        PaddingHorizontal: '24px',
        PaddingTitlesBottom: '2px',
        PaddingVertical: '16px',
      },
    },
  },
  breadcrumbs: {
    default: {
      color: {
        current: '#3a3a3a',
        separator: '#575757',
      },
      sizing: {
        separator: {
          height: '12px',
          width: '12px',
        },
      },
      spacing: {
        padding: {
          gap: '4px',
        },
      },
    },
  },
  button: {
    default: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(4,93,103,0)',
            enabled: 'rgba(4,93,103,0)',
            focus: 'rgba(4,93,103,0)',
            hover: 'rgba(4,93,103,0.08)',
            pressed: 'rgba(4,93,103,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            focus: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
        outline: '#001a17',
        primary: {
          background: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            focus: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#001a17',
          shadow: {
            enabled: 'rgba(4,93,103,0.32)',
            hover: 'rgba(0,64,58,0.32)',
            pressed: 'rgba(0,38,35,0.32)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(4,93,103,0)',
            enabled: 'rgba(4,93,103,0)',
            focus: 'rgba(4,93,103,0)',
            hover: 'rgba(4,93,103,0.08)',
            pressed: 'rgba(4,93,103,0.16)',
          },
          border: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
            focus: '#949494',
            hover: '#00403a',
            pressed: '#002623',
          },
          content: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            focus: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
        tertiary: {
          background: {
            disabled: 'rgba(232,232,232,0.48)',
            enabled: '#e8e8e8',
            focus: '#e8e8e8',
            hover: 'rgba(4,93,103,0.08)',
            pressed: 'rgba(4,93,103,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            focus: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
      },
      radius: {
        small: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
        standard: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    error: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(189,1,0,0)',
            enabled: 'rgba(189,1,0,0)',
            focus: 'rgba(189,1,0,0)',
            hover: 'rgba(189,1,0,0.08)',
            pressed: 'rgba(189,1,0,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#bd0100',
            hover: '#990000',
            pressed: '#660000',
          },
        },
        outline: '#001a17',
        primary: {
          background: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#bd0100',
            hover: '#990000',
            pressed: '#660000',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          shadow: {
            enabled: 'rgba(189,1,0,0.40)',
            hover: 'rgba(189,1,0,0.48)',
            pressed: 'rgba(189,1,0,0.56)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(189,1,0,0)',
            enabled: 'rgba(189,1,0,0)',
            focus: 'rgba(189,1,0,0)',
            hover: 'rgba(189,1,0,0.08)',
            pressed: 'rgba(189,1,0,0.16)',
          },
          border: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
            focus: '#949494',
            hover: '#990000',
            pressed: '#660000',
          },
          content: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#bd0100',
            hover: '#990000',
            pressed: '#660000',
          },
        },
        tertiary: {
          background: {
            disabled: 'rgba(232,232,232,0.48)',
            enabled: '#e8e8e8',
            focus: '#e8e8e8',
            hover: 'rgba(189,1,0,0.08)',
            pressed: 'rgba(189,1,0,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#bd0100',
            hover: '#990000',
            pressed: '#660000',
          },
        },
      },
      radius: {
        small: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
        standard: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    onColor: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(4,93,103,0)',
            enabled: 'rgba(4,93,103,0)',
            focus: 'rgba(4,93,103,0)',
            hover: 'rgba(4,93,103,0.40)',
            pressed: 'rgba(4,93,103,0.48)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        outline: '#e6fcfe',
        primary: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#f7f7f7',
            pressed: '#e8e8e8',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            focus: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
          shadow: {
            enabled: 'rgba(87,87,87,0)',
            hover: 'rgba(87,87,87,0)',
            pressed: 'rgba(87,87,87,0)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(87,87,87,0)',
            enabled: 'rgba(87,87,87,0)',
            focus: 'rgba(87,87,87,0)',
            hover: 'rgba(87,87,87,0.08)',
            pressed: 'rgba(87,87,87,0.16)',
          },
          border: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#e8e8e8',
            focus: '#e8e8e8',
            hover: '#dddddd',
            pressed: '#c7c7c7',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#001a17',
        },
        tertiary: {
          background: {
            disabled: 'rgba(23,27,38,0.24)',
            enabled: 'rgba(23,27,38,0.40)',
            focus: 'rgba(23,27,38,0.40)',
            hover: 'rgba(4,93,103,0.40)',
            pressed: 'rgba(4,93,103,0.56)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
      },
      radius: {
        small: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
        standard: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    onColorInverse: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(230,252,254,0)',
            enabled: 'rgba(230,252,254,0)',
            focus: 'rgba(230,252,254,0)',
            hover: 'rgba(230,252,254,0.40)',
            pressed: 'rgba(230,252,254,0.48)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
        outline: '#001a17',
        primary: {
          background: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(206,248,253,0.48)',
            enabled: '#a7f3fc',
            focus: '#a7f3fc',
            hover: '#cef8fd',
            pressed: '#e6fcfe',
          },
          shadow: {
            enabled: 'rgba(87,87,87,0)',
            hover: 'rgba(87,87,87,0)',
            pressed: 'rgba(87,87,87,0)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(230,252,254,0.40)',
            pressed: 'rgba(230,252,254,0.48)',
          },
          border: {
            disabled: 'rgba(87,87,87,0.48)',
            enabled: '#575757',
            focus: '#575757',
            hover: '#00403a',
            pressed: '#002623',
          },
          content: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
          outline: '#001a17',
        },
        tertiary: {
          background: {
            disabled: 'rgba(232,232,232,0.16)',
            enabled: 'rgba(232,232,232,0.56)',
            focus: 'rgba(245,248,246,0.48)',
            hover: 'rgba(230,252,254,0.72)',
            pressed: 'rgba(230,252,254,0.80)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            focus: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
      },
      radius: {
        small: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
        standard: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    success: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(2,120,21,0)',
            enabled: 'rgba(2,120,21,0)',
            focus: 'rgba(2,120,21,0)',
            hover: 'rgba(2,120,21,0.04)',
            pressed: 'rgba(2,120,21,0.08)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(2,120,21,0.48)',
            enabled: '#027815',
            focus: '#027815',
            hover: '#005e0f',
            pressed: '#00450b',
          },
        },
        outline: '#001a17',
        primary: {
          background: {
            disabled: 'rgba(2,120,21,0.48)',
            enabled: '#027815',
            focus: '#027815',
            hover: '#005e0f',
            pressed: '#00450b',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          shadow: {
            enabled: 'rgba(2,120,21,0.40)',
            hover: 'rgba(2,120,21,0.48)',
            pressed: 'rgba(2,120,21,0.56)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(2,120,21,0)',
            enabled: 'rgba(2,120,21,0)',
            focus: 'rgba(2,120,21,0)',
            hover: 'rgba(2,120,21,0.04)',
            pressed: 'rgba(2,120,21,0.08)',
          },
          border: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
            focus: '#949494',
            hover: '#005e0f',
            pressed: '#00450b',
          },
          content: {
            disabled: 'rgba(2,120,21,0.48)',
            enabled: '#027815',
            focus: '#027815',
            hover: '#005e0f',
            pressed: '#00450b',
          },
        },
        tertiary: {
          background: {
            disabled: 'rgba(232,232,232,0.48)',
            enabled: '#e8e8e8',
            focus: '#e8e8e8',
            hover: 'rgba(2,120,21,0.04)',
            pressed: 'rgba(2,120,21,0.08)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(2,120,21,0.48)',
            enabled: '#027815',
            focus: '#027815',
            hover: '#005e0f',
            pressed: '#00450b',
          },
        },
      },
      radius: {
        small: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
        standard: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
  },
  card: {
    default: {
      color: {
        border: {
          disabled: 'rgba(232,232,232,0.48)',
          enabled: '#e8e8e8',
          focus: '#001a17',
          hover: '#dddddd',
          pressed: '#c7c7c7',
        },
        container: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#f7f7f7',
          pressed: '#e8e8e8',
        },
        contentBackground: '#e8e8e8',
        danger: '#bd0100',
        dataViz: {
          solid: '#006cff',
          transparent: 'rgba(0,108,255,0.32)',
        },
        decorative1: '#006cff',
        decorative2: '#ff9300',
        decorative3: '#cdda01',
        decorative4: '#00a3e0',
        decorative5: '#00bfb3',
        icon: '#00ccb6',
        label: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
        neutral: '#575757',
        sublabel: {
          disabled: 'rgba(87,87,87,0.48)',
          enabled: '#575757',
          hover: '#444444',
          pressed: '#333333',
        },
        success: '#027815',
        warning: '#926b00',
      },
      radius: '12px',
      spacing: {
        body: {
          content: {
            padding: {
              bottom: '16px',
              gap: '0',
              left: '16px',
              right: '16px',
              top: '0',
            },
          },
          padding: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
        },
        footer: {
          actions: {
            bottom: '0',
            gap: '8px',
            left: '0',
            right: '0',
            top: '0',
          },
          padding: {
            bottom: '16px',
            gap: '16px',
            left: '16px',
            right: '16px',
            top: '16px',
          },
        },
        header: {
          content: {
            padding: {
              bottom: '16px',
              gap: '16px',
              left: '16px',
              right: '16px',
              top: '16px',
            },
          },
          leading: {
            padding: {
              bottom: '0',
              gap: '8px',
              left: '0',
              right: '0',
              top: '0',
            },
          },
          padding: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
          trailing: {
            padding: {
              bottom: '16px',
              gap: '8px',
              left: '0',
              right: '16px',
              top: '16px',
            },
          },
        },
        padding: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  chatBubble: {
    default: {
      color: {
        reply: {
          background: '#ffffff',
          senderLabel: '#ffffff',
          text: '#3a3a3a',
        },
        user: {
          background: '#f0fffd',
          senderLabel: '#ffffff',
          text: '#3a3a3a',
        },
      },
      radius: {
        reply: {
          bottomLeft: '4px',
          bottomRight: '24px',
          topLeft: '24px',
          topRight: '24px',
        },
        user: {
          bottomLeft: '24px',
          bottomRight: '4px',
          topLeft: '24px',
          topRight: '24px',
        },
      },
      spacing: {
        footer: {
          actions: {
            gap: '4px',
          },
          gap: '8px',
          top: '4px',
        },
        reply: {
          bottom: '16px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        replyWithContent: {
          avatar: {
            bottom: '12px',
            left: '16px',
            right: '16px',
            top: '24px',
          },
          default: {
            bottom: '8px',
            left: '16px',
            right: '16px',
            top: '16px',
          },
          suggestion: {
            actions: {
              bottom: '0',
              gap: '8px',
              left: '16px',
              right: '16px',
              top: '0',
            },
            container: {
              bottom: '24px',
              gap: '16px',
              left: '0',
              right: '0',
              top: '12px',
            },
            header: {
              bottom: '0',
              left: '16px',
              right: '16px',
              top: '0',
            },
          },
        },
        user: {
          bottom: '16px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
      },
    },
  },
  chatInputField: {
    default: {
      color: {
        scrollbar: 'rgba(87,87,87,0.16)',
        sendButton: {
          disabled: 'rgba(4,93,103,0.48)',
          enabled: '#045d67',
        },
      },
      radius: {
        actions: {
          bottomLeft: '24px',
          bottomRIght: '24px',
          topLeft: '0',
          topRight: '0',
        },
        focus: '24px',
        input: {
          bottomLeft: '0',
          bottomRight: '0',
          topLeft: '24px',
          topRight: '24px',
        },
      },
      spacing: {
        actions: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '8px',
          top: '8px',
        },
        input: {
          bottom: '12px',
          left: '16px',
          right: '16px',
          top: '12px',
        },
      },
    },
  },
  chatbot: {
    default: {
      body: {
        sizing: {
          max: {
            width: '1200px',
          },
        },
        spacing: {
          leftSlot: {
            bottom: '8px',
            gap: '0',
            left: '24px',
            progressIndicator: {
              padding: '0',
            },
            right: '72px',
            top: '8px',
          },
          rightSlot: {
            bottom: '8px',
            gap: '0',
            left: '72px',
            right: '24px',
            top: '8px',
          },
        },
      },
      container: {
        radius: {
          bottomLeft: '24px',
          bottomRight: '4px',
          topLeft: '24px',
          topRight: '24px',
        },
        shadow: {
          blur: '24px',
          color: 'rgba(87,87,87,0.16)',
          spread: '2px',
          x: '0',
          y: '8px',
        },
        sizing: {
          minHeight: '600px',
          minWidth: '600px',
        },
      },
      fab: {
        color: {
          border: 'rgba(255,255,255,0.48)',
          state: {
            disabled: 'rgba(13,13,13,0)',
            enabled: 'rgba(13,13,13,0)',
            focus: 'rgba(13,13,13,0)',
            hover: 'rgba(13,13,13,0.16)',
            pressed: 'rgba(13,13,13,0.32)',
          },
        },
        radius: {
          bottomLeft: '24px',
          bottomRight: '4px',
          topLeft: '24px',
          topRight: '24px',
        },
        spacing: {
          left: '8px',
        },
      },
      footer: {
        color: {
          background: 'rgba(153,0,89,0.72)',
          disclaimer: {
            text: {
              enabled: '#ffffff',
            },
            textLink: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              focusOutline: '#e6fcfe',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
          },
        },
        sizing: {
          max: {
            width: '1200px',
          },
        },
        spacing: {
          bottom: '8px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '16px',
        },
      },
      gradient: {
        end: '#00ccb6',
        start: '#006cff',
      },
      header: {
        color: {
          background: 'rgba(37,0,86,0.72)',
          border: 'rgba(255,255,255,0.48)',
          title: '#ffffff',
        },
        spacing: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          rightIcons: {
            gap: '8px',
          },
          top: '16px',
        },
      },
    },
  },
  checkbox: {
    default: {
      border: {
        control: '1px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(4,93,103,0.48)',
              enabled: '#045d67',
              focus: '#045d67',
              hover: '#00403a',
              pressed: '#002623',
            },
            unselected: {
              disabled: 'rgba(4,93,103,0)',
              enabled: 'rgba(4,93,103,0)',
              focus: 'rgba(4,93,103,0)',
              hover: 'rgba(4,93,103,0.08)',
              pressed: 'rgba(4,93,103,0.16)',
            },
          },
          border: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
            focus: '#949494',
            hover: '#00403a',
            pressed: '#002623',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        help: {
          enabled: '#575757',
        },
        label: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          focus: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
        outline: '#001a17',
      },
      radius: {
        control: '4px',
        focus: '12px',
      },
      sizing: {
        control: {
          container: {
            height: '24px',
            width: '24px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
            wrap: '0',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    error: {
      border: {
        control: '2px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(189,1,0,0.48)',
              enabled: '#bd0100',
              focus: '#bd0100',
              hover: '#990000',
              pressed: '#660000',
            },
            unselected: {
              disabled: 'rgba(189,1,0,0)',
              enabled: 'rgba(189,1,0,0)',
              focus: 'rgba(189,1,0,0)',
              hover: 'rgba(189,1,0,0.08)',
              pressed: 'rgba(189,1,0,0.16)',
            },
          },
          border: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#bd0100',
            focus: '#bd0100',
            hover: '#990000',
            pressed: '#660000',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        help: {
          enabled: '#bd0100',
        },
        label: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          focus: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
        outline: '#001a17',
      },
      radius: {
        control: '4px',
        focus: '12px',
      },
      sizing: {
        control: {
          container: {
            height: '24px',
            width: '24px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
            wrap: '0',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  chip: {
    default: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            focus: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
          unselected: {
            disabled: 'rgba(4,93,103,0)',
            enabled: 'rgba(4,93,103,0)',
            focus: 'rgba(4,93,103,0)',
            hover: 'rgba(4,93,103,0.08)',
            pressed: 'rgba(4,93,103,0.16)',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          unselected: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
            focus: '#949494',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
        icon: {
          selected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          unselected: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
        label: {
          selected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          unselected: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
        outline: '#001a17',
      },
      radius: {
        small: '9999px',
        standard: '9999px',
      },
      sizing: {
        small: {
          height: '24px',
          icon: '24px',
        },
        standard: {
          height: '40px',
          icon: '24px',
        },
      },
      spacing: {
        group: {
          gap: '8px',
        },
        small: {
          bottom: '2px',
          gap: '0',
          icon: {
            left: '4px',
          },
          label: {
            left: '4px',
            right: '4px',
          },
          left: '2px',
          right: '2px',
          top: '2px',
        },
        standard: {
          bottom: '4px',
          gap: '0',
          icon: {
            left: '4px',
          },
          label: {
            left: '8px',
            right: '8px',
          },
          left: '4px',
          right: '4px',
          top: '4px',
        },
      },
    },
  },
  columnSettingsMenu: {
    default: {
      color: {
        background: {
          default: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#f7f7f7',
            pressed: '#e6fcfe',
          },
          frozen: {
            disabled: 'rgba(245,248,246,0.48)',
            enabled: '#f5f8f6',
            focus: '#f5f8f6',
            hover: '#edf2ef',
            pressed: '#e4ece7',
          },
        },
        border: {
          frozenUnchecked: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
            focus: '#949494',
            hover: '#696969',
            pressed: '#575757',
          },
        },
        focusOutline: '#001a17',
        icon: {
          disabled: 'rgba(153,153,153,0.48)',
          enabled: '#999999',
          focus: '#999999',
          hover: '#777777',
          pressed: '#555555',
        },
        label: {
          default: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
          frozen: {
            disabled: 'rgba(87,87,87,0.48)',
            enabled: '#575757',
            focus: '#575757',
            hover: '#444444',
            pressed: '#333333',
          },
        },
        outline: '#001a17',
      },
      height: {
        leadingIcon: '21px',
      },
      padding: {
        freezeLine: {
          right: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '24px',
          top: '8px',
        },
      },
      radius: {
        cell: '0',
        column: '12px',
        focusOutline: '12px',
      },
      strokeWidth: {
        focusOutline: '2px',
      },
    },
  },
  control: {
    default: {
      color: {
        focus: '#000000',
      },
    },
    error: {
      color: {
        focus: '#000000',
      },
    },
  },
  datePicker: {
    default: {
      color: {
        calendar: {
          border: '#e8e8e8',
          container: '#ffffff',
        },
        dayOption: {
          badgeEnabled: '#045d67',
          badgeHover: '#00403a',
          badgeSelected: '#ffffff',
          fillEnabled: '#ffffff',
          fillEnabledHover: '#ffffff',
          fillSelected: '#045d67',
          fillSelectedHover: '#00403a',
          todayEnabled: '#575757',
          todayHover: '#444444',
          todaySelected: '#ffffff',
        },
        option: {
          badgeEnabled: '#045d67',
          badgeHover: '#00403a',
          badgeSelected: '#a7f3fc',
          fillEnabled: '#ffffff',
          fillEnabledHover: '#cef8fd',
          fillSelected: '#045d67',
          fillSelectedHover: '#00403a',
          todayEnabled: '#575757',
          todayHover: '#444444',
          todaySelected: '#a7f3fc',
        },
        typography: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          hover: '#242424',
          selected: '#ffffff',
          static: '#575757',
        },
      },
      minWidth: '104px',
      radius: {
        option: '9999px',
      },
      sizing: {
        containerMinWidth: '320px',
        dayMaxHeight: '48px',
        dayMaxWidth: '48px',
        dialogMaxHeight: '392px',
        dialogMinWidth: '320px',
        optionMaxHeight: '40px',
        optionMinWidth: '64px',
        small: {
          minWidth: '97px',
        },
        standard: {
          minWidth: '114px',
        },
      },
      spacing: {
        calendarGap: '8px',
        dialogPadding: '16px',
        optionRowGap: '16px',
        small: {
          textGap: '4px',
        },
        standard: {
          textGap: '8px',
        },
      },
    },
  },
  divider: {
    default: {
      color: {
        dark: '#575757',
        light: '#e8e8e8',
        medium: '#949494',
        semiOpaque: 'rgba(255,255,255,0.48)',
      },
    },
  },
  dragAndDrop: {
    default: {
      background: 'rgba(232,232,232,0.40)',
    },
  },
  fab: {
    default: {
      radius: {
        bottomLeft: '9999px',
        bottomRight: '9999px',
        topLeft: '9999px',
        topRight: '9999px',
      },
      shadow: {
        blur: '24px',
        color: 'rgba(87,87,87,0.16)',
        spread: '2px',
        x: '0',
        y: '8px',
      },
      sizing: {
        label: {
          min: {
            width: '64px',
          },
        },
        noLabel: {
          height: '48px',
          width: '48px',
        },
      },
    },
  },
  fileUploader: {
    default: {
      color: {
        dropZone: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#cef8fd',
            pressed: '#a7f3fc',
          },
          border: {
            disabled: 'rgba(87,87,87,0.48)',
            enabled: '#575757',
            focus: '#575757',
            hover: '#00403a',
            pressed: '#002623',
          },
          content: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            focus: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
        fileListItem: {
          iconError: {
            enabled: '#bd0100',
          },
          iconSuccess: {
            enabled: '#027815',
          },
          text: {
            enabled: '#3a3a3a',
          },
        },
        help: {
          enabled: '#575757',
        },
      },
      spacing: {
        dropZone: {
          gap: '0',
          padding: '8px',
        },
        fileList: {
          padding: {
            right: '0',
          },
        },
        fileListItem: {
          padding: {
            bottom: '8px',
            gapIcon: '8px',
            gapText: '2px',
            left: '4px',
            min: '160px',
            right: '4px',
            top: '8px',
          },
        },
        minWidth: '240px',
        radius: '12px',
      },
    },
    error: {
      color: {
        dropZone: {
          background: {
            disabled: '#fcebeb',
            enabled: '#fcebeb',
            focus: '#fcebeb',
            hover: '#fcebeb',
            pressed: '#fcebeb',
          },
          border: {
            disabled: '#990000',
            enabled: '#990000',
            focus: '#990000',
            hover: '#990000',
            pressed: '#990000',
          },
          content: {
            disabled: '#990000',
            enabled: '#990000',
            focus: '#990000',
            hover: '#990000',
            pressed: '#990000',
          },
        },
        fileListItem: {
          iconError: {
            enabled: '#bd0100',
          },
          iconSuccess: {
            enabled: '#027815',
          },
          text: {
            enabled: '#3a3a3a',
          },
        },
        help: {
          enabled: '#575757',
        },
      },
      spacing: {
        dropZone: {
          gap: '0',
          padding: '8px',
        },
        fileList: {
          padding: {
            right: '0',
          },
        },
        fileListItem: {
          padding: {
            bottom: '8px',
            gapIcon: '8px',
            gapText: '2px',
            left: '4px',
            min: '160px',
            right: '4px',
            top: '8px',
          },
        },
        minWidth: '240px',
        radius: '12px',
      },
    },
  },
  floatingActionColumn: {
    default: {
      border: {
        color: '#c7c7c7',
        stroke: '1px',
      },
      padding: {
        gap: '0',
        horizontal: '0',
        vertical: '0',
      },
      radius: {
        radius: '0',
      },
      shadow: {
        blur: '20px',
        color: 'rgba(87,87,87,0.16)',
        spread: '0',
        x: '-8px',
        y: '0',
      },
    },
  },
  footer: {
    default: {
      color: {
        content: '#3a3a3a',
      },
      sizing: {
        widthMin: '320px',
      },
      spacing: {
        bottomPadding: '24px',
        itemGap: '32px',
        rowGap: '24px',
        sidePadding: '40px',
        topPadding: '40px',
      },
    },
    defaultInverse: {
      color: {
        content: '#ffffff',
      },
      sizing: {
        widthMin: '320px',
      },
      spacing: {
        bottomPadding: '24px',
        itemGap: '32px',
        rowGap: '24px',
        sidePadding: '40px',
        topPadding: '40px',
      },
    },
  },
  functional: {
    borderWidth: {
      focus: {
        default: '2px',
      },
    },
    color: {
      border: {
        accent: {
          disabled: 'rgba(0,204,182,0.48)',
          enabled: '#00897a',
          hover: '#00665b',
          pressed: '#00332d',
        },
        brand: {
          disabled: 'rgba(4,93,103,0.48)',
          enabled: '#045d67',
          hover: '#00403a',
          pressed: '#002623',
        },
        danger: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        default: {
          disabled: 'rgba(148,148,148,0.48)',
          enabled: '#949494',
          hover: '#696969',
          pressed: '#575757',
        },
        'default-inverse': {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        defaultInverse: {
          disabled: 'rgba(87,87,87,0.48)',
          enabled: '#575757',
          hover: '#444444',
          pressed: '#333333',
        },
        focus: '#001a17',
        'focus-inverse': '#ffffff',
        focusInverse: '#e6fcfe',
        subtle: {
          disabled: 'rgba(232,232,232,0.48)',
          enabled: '#e8e8e8',
          hover: '#dddddd',
          pressed: '#c7c7c7',
        },
        success: {
          disabled: 'rgba(2,120,21,0.48)',
          enabled: '#027815',
          hover: '#005e0f',
          pressed: '#00450b',
        },
        transparent: 'rgba(255,255,255,0)',
        warning: {
          disabled: 'rgba(120,88,0,0.48)',
          enabled: '#926b00',
          hover: '#785800',
          pressed: '#614700',
        },
        white: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
      },
      content: {
        accent: {
          disabled: 'rgba(0,204,182,0.48)',
          enabled: '#00ccb6',
          hover: '#00897a',
          pressed: '#00665b',
        },
        'accent-inverse': {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: 'rgba(230,230,230,1)',
          hover: 'rgba(230,230,230,1)',
          pressed: 'rgba(230,230,230,1)',
        },
        accentInverse: {
          disabled: 'rgba(240,255,253,0.48)',
          enabled: '#dbfffb',
          hover: '#e5fffc',
          pressed: '#f0fffd',
        },
        brand: {
          disabled: 'rgba(4,93,103,0.48)',
          enabled: '#045d67',
          hover: '#00403a',
          pressed: '#002623',
        },
        'brand-inverse': {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        brandInverse: {
          disabled: 'rgba(206,248,253,0.48)',
          enabled: '#a7f3fc',
          hover: '#cef8fd',
          pressed: '#e6fcfe',
        },
        danger: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        'danger-inverse': {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        dangerInverse: {
          disabled: 'rgba(252,235,235,0.48)',
          enabled: '#ffb2b2',
          hover: '#ffcccc',
          pressed: '#fcebeb',
        },
        default: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
        'default-inverse': {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        defaultInverse: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        subtle: {
          disabled: 'rgba(87,87,87,0.48)',
          enabled: '#575757',
          hover: '#444444',
          pressed: '#333333',
        },
        'subtle-inverse': {
          disabled: '#ffffff',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        subtleInverse: {
          disabled: 'rgba(232,232,232,0.48)',
          enabled: '#e8e8e8',
          hover: '#dddddd',
          pressed: '#ffffff',
        },
        success: {
          disabled: 'rgba(2,120,21,0.48)',
          enabled: '#027815',
          hover: '#005e0f',
          pressed: '#00450b',
        },
        'success-inverse': {
          disabled: 'rgba(255,255,255,0)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        successInverse: {
          disabled: 'rgba(229,255,234,0.48)',
          enabled: '#b2ffbf',
          hover: '#ccffd4',
          pressed: '#e5ffea',
        },
        warning: {
          disabled: 'rgba(244,198,90,0.48)',
          enabled: '#f4c65a',
          hover: '#f7d991',
          pressed: '#fbecc8',
        },
        'warning-inverse': {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        warningInverse: {
          disabled: 'rgba(120,88,0,0.48)',
          enabled: '#926b00',
          hover: '#785800',
          pressed: '#614700',
        },
      },
      dataViz: {
        content: {
          axis: '#808080',
          label: '#4d4d4d',
          title: {
            enabled: '#333333',
            hover: '#2e2e2e',
            pressed: '#292929',
          },
        },
        five: {
          enabled: '#005587',
          hover: '#005587',
          pressed: '#005587',
        },
        four: {
          enabled: '#3a3a3a',
          hover: '#3a3a3a',
          pressed: '#3a3a3a',
        },
        gray: {
          enabled: '#bfbfbf',
          hover: '#bfbfbf',
          pressed: '#bfbfbf',
        },
        one: {
          enabled: '#00ccb6',
          hover: '#00ccb6',
          pressed: '#00ccb6',
        },
        six: {
          enabled: '#d18100',
          hover: '#d18100',
          pressed: '#d18100',
        },
        three: {
          enabled: '#045d67',
          hover: '#045d67',
          pressed: '#045d67',
        },
        two: {
          enabled: '#cdda01',
          hover: '#cdda01',
          pressed: '#cdda01',
        },
      },
      decorative: {
        five: {
          contrast: '#004d48',
          enabled: '#00bfb3',
          hover: 'rgba(0,191,179,0.08)',
          inverse: '#e5fffd',
          pressed: 'rgba(0,191,179,0.32)',
        },
        four: {
          contrast: '#004a66',
          enabled: '#00a3e0',
          hover: 'rgba(0,163,224,0.08)',
          inverse: '#e5f8ff',
          pressed: 'rgba(0,163,224,0.32)',
        },
        one: {
          contrast: '#004199',
          enabled: '#006cff',
          hover: 'rgba(0,108,255,0.08)',
          inverse: '#e5f0ff',
          pressed: 'rgba(0,108,255,0.32)',
        },
        three: {
          contrast: '#8f9801',
          enabled: '#cdda01',
          hover: 'rgba(205,218,1,0.08)',
          inverse: '#fdffe6',
          pressed: 'rgba(205,218,1,0.32)',
        },
        two: {
          contrast: '#995900',
          enabled: '#ff9300',
          hover: 'rgba(255,147,0,0.08)',
          inverse: '#fff4e5',
          pressed: 'rgba(255,147,0,0.32)',
        },
      },
      surface: {
        background: {
          disabled: 'rgba(245,248,246,0.48)',
          enabled: '#f5f8f6',
          hover: '#edf2ef',
          pressed: '#e4ece7',
        },
        'background-inverse': {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        backgroundInverse: {
          disabled: 'rgba(23,27,38,0.48)',
          enabled: '#0c0f18',
          hover: '#171b26',
          pressed: '#292c32',
        },
        container: {
          gradient: {
            accent: {
              end: '#00897a',
              start: '#045d67',
            },
            brand: {
              end: '#045d67',
              start: '#00403a',
            },
            neutral: {
              end: '#f5f8f6',
              start: '#00897a',
            },
            neutralInverse: {
              end: '#444444',
              start: '#333333',
            },
          },
          opaque: {
            accent: {
              disabled: 'rgba(0,204,182,0.40)',
              enabled: 'rgba(0,204,182,0.72)',
              hover: 'rgba(0,204,182,0.80)',
              pressed: 'rgba(0,204,182,0.88)',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            accentInverse: {
              disabled: 'rgba(240,255,253,0.40)',
              enabled: 'rgba(240,255,253,0.72)',
              hover: 'rgba(240,255,253,0.80)',
              pressed: 'rgba(240,255,253,0.88)',
            },
            background: {
              disabled: 'rgba(246,247,251,0.40)',
              enabled: 'rgba(245,248,246,0.72)',
              hover: 'rgba(245,248,246,0.80)',
              pressed: 'rgba(245,248,246,0.88)',
            },
            'background-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            backgroundInverse: {
              disabled: 'rgba(23,27,38,0.40)',
              enabled: 'rgba(23,27,38,0.72)',
              hover: 'rgba(23,27,38,0.80)',
              pressed: 'rgba(23,27,38,0.88)',
            },
            brand: {
              disabled: 'rgba(4,93,103,0.40)',
              enabled: 'rgba(4,93,103,0.72)',
              hover: 'rgba(4,93,103,0.80)',
              pressed: 'rgba(4,93,103,0.88)',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            brandInverse: {
              disabled: 'rgba(230,252,254,0.40)',
              enabled: 'rgba(230,252,254,0.72)',
              hover: 'rgba(230,252,254,0.80)',
              pressed: 'rgba(230,252,254,0.88)',
            },
            danger: {
              disabled: 'rgba(189,1,0,0.40)',
              enabled: 'rgba(189,1,0,0.72)',
              hover: 'rgba(189,1,0,0.80)',
              pressed: 'rgba(189,1,0,0.88)',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            dangerInverse: {
              disabled: 'rgba(252,235,235,0.40)',
              enabled: 'rgba(252,235,235,0.72)',
              hover: 'rgba(252,235,235,0.80)',
              pressed: 'rgba(252,235,235,0.88)',
            },
            default: {
              disabled: 'rgba(255,255,255,0.40)',
              enabled: 'rgba(255,255,255,0.72)',
              hover: 'rgba(255,255,255,0.80)',
              pressed: 'rgba(232,232,232,0.88)',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            defaultInverse: {
              disabled: 'rgba(87,87,87,0.40)',
              enabled: 'rgba(87,87,87,0.72)',
              hover: 'rgba(87,87,87,0.80)',
              pressed: 'rgba(87,87,87,0.88)',
            },
            subtle: {
              disabled: 'rgba(232,232,232,0.40)',
              enabled: 'rgba(232,232,232,0.72)',
              hover: 'rgba(232,232,232,0.80)',
              pressed: 'rgba(232,232,232,0.88)',
            },
            'subtle-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            subtleInverse: {
              disabled: 'rgba(148,148,148,0.40)',
              enabled: 'rgba(148,148,148,0.72)',
              hover: 'rgba(148,148,148,0.80)',
              pressed: 'rgba(148,148,148,0.88)',
            },
            success: {
              disabled: 'rgba(2,120,21,0.40)',
              enabled: 'rgba(2,120,21,0.72)',
              hover: 'rgba(2,120,21,0.80)',
              pressed: 'rgba(2,120,21,0.88)',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            successInverse: {
              disabled: 'rgba(229,255,234,0.40)',
              enabled: 'rgba(229,255,234,0.72)',
              hover: 'rgba(229,255,234,0.80)',
              pressed: 'rgba(229,255,234,0.88)',
            },
            warning: {
              disabled: 'rgba(240,179,35,0.40)',
              enabled: 'rgba(240,179,35,0.72)',
              hover: 'rgba(240,179,35,0.80)',
              pressed: 'rgba(240,179,35,0.88)',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warningInverse: {
              disabled: 'rgba(244,198,90,0.40)',
              enabled: 'rgba(244,198,90,0.72)',
              hover: 'rgba(244,198,90,0.80)',
              pressed: 'rgba(244,198,90,0.88)',
            },
          },
          solid: {
            accent: {
              disabled: 'rgba(0,204,182,0.48)',
              enabled: '#00ccb6',
              hover: '#00897a',
              pressed: '#00665b',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0.48)',
              enabled: 'rgba(230,230,230,1)',
              hover: 'rgba(230,230,230,1)',
              pressed: 'rgba(230,230,230,1)',
            },
            accentInverse: {
              disabled: 'rgba(240,255,253,0.48)',
              enabled: '#f0fffd',
              hover: '#e5fffc',
              pressed: '#dbfffb',
            },
            brand: {
              disabled: 'rgba(4,93,103,0.48)',
              enabled: '#045d67',
              hover: '#00403a',
              pressed: '#002623',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            brandInverse: {
              disabled: 'rgba(230,252,254,0.48)',
              enabled: '#e6fcfe',
              hover: '#cef8fd',
              pressed: '#a7f3fc',
            },
            danger: {
              disabled: 'rgba(189,1,0,0.48)',
              enabled: '#bd0100',
              hover: '#990000',
              pressed: '#660000',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            dangerInverse: {
              disabled: 'rgba(252,235,235,0.48)',
              enabled: '#fcebeb',
              hover: '#ffcccc',
              pressed: '#ffb2b2',
            },
            default: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#f7f7f7',
              pressed: '#e8e8e8',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            defaultInverse: {
              disabled: 'rgba(58,58,58,0.48)',
              enabled: '#3a3a3a',
              hover: '#242424',
              pressed: '#030303',
            },
            'focus-outline': '#000000',
            'focus-outline-inverse': '#ffffff',
            focusOutline: '#001a17',
            focusOutlineInverse: '#e6fcfe',
            subtle: {
              disabled: 'rgba(232,232,232,0.48)',
              enabled: '#e8e8e8',
              hover: '#dddddd',
              pressed: '#c7c7c7',
            },
            subtleInverse: {
              disabled: 'rgba(148,148,148,0.48)',
              enabled: '#949494',
              hover: '#696969',
              pressed: '#575757',
            },
            success: {
              disabled: 'rgba(2,120,21,0.48)',
              enabled: '#027815',
              hover: '#005e0f',
              pressed: '#00450b',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            successInverse: {
              disabled: 'rgba(229,255,234,0.48)',
              enabled: '#e5ffea',
              hover: '#ccffd4',
              pressed: '#b2ffbf',
            },
            warning: {
              disabled: 'rgba(240,179,35,0.48)',
              enabled: '#f0b323',
              hover: '#f4c65a',
              pressed: '#f7d991',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            warningInverse: {
              disabled: 'rgba(244,198,90,0.48)',
              enabled: '#fbecc8',
              hover: '#f7d991',
              pressed: '#f4c65a',
            },
          },
          translucent: {
            accent: {
              disabled: 'rgba(0,204,182,0.24)',
              enabled: 'rgba(0,204,182,0.40)',
              hover: 'rgba(0,204,182,0.48)',
              pressed: 'rgba(0,204,182,0.56)',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            accentInverse: {
              disabled: 'rgba(240,255,253,0.24)',
              enabled: 'rgba(240,255,253,0.40)',
              hover: 'rgba(240,255,253,0.48)',
              pressed: 'rgba(240,255,253,0.56)',
            },
            background: {
              disabled: 'rgba(245,248,246,0.56)',
              enabled: 'rgba(245,248,246,0.40)',
              hover: 'rgba(245,248,246,0.48)',
              pressed: 'rgba(245,248,246,0.56)',
            },
            'background-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            backgroundInverse: {
              disabled: 'rgba(23,27,38,0.24)',
              enabled: 'rgba(23,27,38,0.40)',
              hover: 'rgba(23,27,38,0.48)',
              pressed: 'rgba(23,27,38,0.56)',
            },
            brand: {
              disabled: 'rgba(4,93,103,0.24)',
              enabled: 'rgba(4,93,103,0.40)',
              hover: 'rgba(4,93,103,0.48)',
              pressed: 'rgba(4,93,103,0.56)',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            brandInverse: {
              disabled: 'rgba(230,252,254,0.24)',
              enabled: 'rgba(230,252,254,0.40)',
              hover: 'rgba(230,252,254,0.48)',
              pressed: 'rgba(230,252,254,0.56)',
            },
            danger: {
              disabled: 'rgba(189,1,0,0.24)',
              enabled: 'rgba(189,1,0,0.40)',
              hover: 'rgba(189,1,0,0.48)',
              pressed: 'rgba(189,1,0,0.56)',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            dangerInverse: {
              disabled: 'rgba(252,235,235,0.24)',
              enabled: 'rgba(252,235,235,0.40)',
              hover: 'rgba(252,235,235,0.48)',
              pressed: 'rgba(252,235,235,0.56)',
            },
            default: {
              disabled: 'rgba(255,255,255,0.24)',
              enabled: 'rgba(255,255,255,0.40)',
              hover: 'rgba(255,255,255,0.48)',
              pressed: 'rgba(232,232,232,0.56)',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            defaultInverse: {
              disabled: 'rgba(87,87,87,0.24)',
              enabled: 'rgba(87,87,87,0.40)',
              hover: 'rgba(87,87,87,0.48)',
              pressed: 'rgba(87,87,87,0.56)',
            },
            subtle: {
              disabled: 'rgba(232,232,232,0.24)',
              enabled: 'rgba(232,232,232,0.40)',
              hover: 'rgba(232,232,232,0.48)',
              pressed: 'rgba(232,232,232,0.56)',
            },
            'subtle-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            subtleInverse: {
              disabled: 'rgba(148,148,148,0.24)',
              enabled: 'rgba(148,148,148,0.40)',
              hover: 'rgba(148,148,148,0.48)',
              pressed: 'rgba(148,148,148,0.56)',
            },
            success: {
              disabled: 'rgba(2,120,21,0.16)',
              enabled: 'rgba(2,120,21,0.40)',
              hover: 'rgba(2,120,21,0.48)',
              pressed: 'rgba(2,120,21,0.56)',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            successInverse: {
              disabled: 'rgba(229,255,234,0.16)',
              enabled: 'rgba(229,255,234,0.40)',
              hover: 'rgba(229,255,234,0.48)',
              pressed: 'rgba(229,255,234,0.56)',
            },
            warning: {
              disabled: 'rgba(240,179,35,0.16)',
              enabled: 'rgba(240,179,35,0.40)',
              hover: 'rgba(240,179,35,0.48)',
              pressed: 'rgba(240,179,35,0.56)',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warningInverse: {
              disabled: 'rgba(244,198,90,0.16)',
              enabled: 'rgba(244,198,90,0.40)',
              hover: 'rgba(244,198,90,0.48)',
              pressed: 'rgba(244,198,90,0.56)',
            },
          },
          transparent: {
            accent: {
              disabled: 'rgba(0,204,182,0)',
              enabled: 'rgba(0,204,182,0)',
              hover: 'rgba(0,204,182,0.08)',
              pressed: 'rgba(0,204,182,0.16)',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            accentInverse: {
              disabled: 'rgba(0,204,182,0)',
              enabled: 'rgba(0,204,182,0)',
              hover: 'rgba(0,204,182,0.08)',
              pressed: 'rgba(0,204,182,0.16)',
            },
            background: {
              disabled: 'rgba(246,247,251,0)',
              enabled: 'rgba(245,248,246,0)',
              hover: 'rgba(245,248,246,0.08)',
              pressed: 'rgba(245,248,246,0.16)',
            },
            'background-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            backgroundInverse: {
              disabled: 'rgba(68,68,68,0)',
              enabled: 'rgba(68,68,68,0)',
              hover: 'rgba(68,68,68,0.08)',
              pressed: 'rgba(68,68,68,0.16)',
            },
            brand: {
              disabled: 'rgba(4,93,103,0)',
              enabled: 'rgba(4,93,103,0)',
              hover: 'rgba(4,93,103,0.08)',
              pressed: 'rgba(4,93,103,0.16)',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            brandInverse: {
              disabled: 'rgba(230,252,254,0)',
              enabled: 'rgba(230,252,254,0)',
              hover: 'rgba(230,252,254,0.08)',
              pressed: 'rgba(230,252,254,0.16)',
            },
            danger: {
              disabled: 'rgba(189,1,0,0)',
              enabled: 'rgba(189,1,0,0)',
              hover: 'rgba(189,1,0,0.08)',
              pressed: 'rgba(189,1,0,0.16)',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            dangerInverse: {
              disabled: 'rgba(252,235,235,0)',
              enabled: 'rgba(252,235,235,0)',
              hover: 'rgba(252,235,235,0.08)',
              pressed: 'rgba(252,235,235,0.16)',
            },
            default: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0.08)',
              pressed: 'rgba(232,232,232,0.16)',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            defaultInverse: {
              disabled: 'rgba(87,87,87,0)',
              enabled: 'rgba(87,87,87,0)',
              hover: 'rgba(87,87,87,0.08)',
              pressed: 'rgba(87,87,87,0.16)',
            },
            subtle: {
              disabled: 'rgba(232,232,232,0)',
              enabled: 'rgba(232,232,232,0)',
              hover: 'rgba(232,232,232,0.08)',
              pressed: 'rgba(232,232,232,0.16)',
            },
            subtleInverse: {
              disabled: 'rgba(148,148,148,0.48)',
              enabled: 'rgba(148,148,148,0)',
              hover: 'rgba(148,148,148,0.08)',
              pressed: 'rgba(148,148,148,0.16)',
            },
            success: {
              disabled: 'rgba(2,120,21,0)',
              enabled: 'rgba(2,120,21,0)',
              hover: 'rgba(2,120,21,0.04)',
              pressed: 'rgba(2,120,21,0.08)',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            successInverse: {
              disabled: 'rgba(229,255,234,0)',
              enabled: 'rgba(229,255,234,0)',
              hover: 'rgba(229,255,234,0.04)',
              pressed: 'rgba(229,255,234,0.08)',
            },
            warning: {
              disabled: 'rgba(240,179,35,0)',
              enabled: 'rgba(240,179,35,0)',
              hover: 'rgba(240,179,35,0.04)',
              pressed: 'rgba(240,179,35,0.08)',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warningInverse: {
              disabled: 'rgba(244,198,90,0)',
              enabled: 'rgba(244,198,90,0)',
              hover: 'rgba(244,198,90,0.04)',
              pressed: 'rgba(244,198,90,0.08)',
            },
          },
        },
      },
    },
    radius: {
      action: {
        '100': '9999px',
        '200': '4px',
        '300': '9999px',
      },
      circle: '9999px',
      container: {
        '100': '12px',
        '200': '4px',
        '300': '24px',
      },
      content: {
        '100': '9999px',
        '200': '12px',
        '300': '4px',
        '400': '8px',
        '500': '12px',
      },
      input: {
        '100': '12px',
        '200': '4px',
      },
      navigation: {
        '100': '0',
        '200': '4px',
      },
      none: '0',
      overlay: {
        '100': '12px',
        '200': '2px',
      },
    },
    shadow: {
      levelFour: {
        blur: '24px',
        color: 'rgba(87,87,87,0.16)',
        spread: '2px',
        x: '0',
        y: '8px',
      },
      levelOne: {
        blur: '16px',
        color: 'rgba(87,87,87,0.08)',
        spread: '0',
        x: '0',
        y: '4px',
      },
      levelThree: {
        blur: '20px',
        color: 'rgba(87,87,87,0.16)',
        spread: '0',
        x: '0',
        y: '8px',
      },
      levelTwo: {
        blur: '6px',
        color: 'rgba(4,93,103,0.32)',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      levelTwoHover: {
        blur: '16px',
        color: 'rgba(0,64,58,0.32)',
        spread: '0',
        x: '0',
        y: '4px',
      },
      levelTwoPressed: {
        blur: '4px',
        color: 'rgba(0,38,35,0.32)',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      scrollingOverlay: {
        bottom: {
          blur: '16px',
          spread: '0',
          x: '0',
          y: '-8px',
        },
        color: 'rgba(0,0,0,0.08)',
        left: {
          blur: '16px',
          spread: '0',
          x: '8px',
          y: '0',
        },
        right: {
          blur: '16px',
          spread: '0',
          x: '-8px',
          y: '0',
        },
        stroke: '#c7c7c7',
        top: {
          blur: '16px',
          spread: '0',
          x: '0',
          y: '8px',
        },
      },
    },
    sizing: {
      action: {
        comfortable: '40px',
        compact: '24px',
        cozy: '24px',
        expanded: '48px',
        spacious: '48px',
        vast: '64px',
      },
      breakpoint: {
        compact: '320px',
        large: '1200px',
        medium: '900px',
        small: '600px',
        xl: '1536px',
      },
      container: {
        comfortable: '320px',
        compact: '48px',
        cozy: '64px',
        expanded: '480px',
        spacious: '600px',
      },
      content: {
        comfortable: '16px',
        compact: '8px',
        cozy: '12px',
        expanded: '20px',
        spacious: '24px',
      },
      input: {
        comfortable: '64px',
        compact: '40px',
        cozy: '48px',
        expanded: '160px',
        spacious: '240px',
      },
      lineHeight: {
        bodyDefault: '24px',
        bodySmall: '21px',
        caption: '20px',
        headline: '53px',
        subheadline: '35px',
        subtile: '30px',
        title: '36px',
      },
      navigation: {
        comfortable: '40px',
        compact: '20px',
        cozy: '24px',
        expanded: '56px',
        spacious: '64px',
      },
      none: '0',
      overlay: {
        comfortable: '64px',
        compact: '24px',
        cozy: '48px',
        expanded: '240px',
        spacious: '480px',
      },
    },
    spacing: {
      action: {
        comfortable: '8px',
        compact: '2px',
        cozy: '4px',
        expanded: '24px',
        spacious: '32px',
      },
      container: {
        comfortable: '12px',
        compact: '4px',
        cozy: '8px',
        expanded: '16px',
        spacious: '24px',
      },
      content: {
        comfortable: '8px',
        compact: '2px',
        cozy: '4px',
        expanded: '16px',
        spacious: '24px',
      },
      input: {
        comfortable: '8px',
        compact: '2px',
        cozy: '4px',
        expanded: '12px',
        spacious: '16px',
      },
      navigation: {
        comfortable: '16px',
        compact: '4px',
        cozy: '8px',
        expanded: '24px',
        spacious: '32px',
      },
      none: '0',
      overlay: {
        comfortable: '12px',
        compact: '4px',
        cozy: '8px',
        expanded: '16px',
        spacious: '24px',
      },
    },
  },
  global: {
    motion: {
      default: {
        duration: '200ms',
        easing: 'cubic-bezier(0.38, 0.0, 1, 1)',
        transition: '200ms cubic-bezier(0.38, 0.0, 1, 1)',
      },
      instant: {
        duration: '0ms',
      },
    },
    typography: {
      default: {
        fontFamily: "'Proxima Nova', 'Nunito Sans', 'Noto Sans', 'Helvetica', 'Arial', sans-serif",
      },
    },
  },
  grid: {
    color: {
      solid: {
        default: {
          accent: {
            background: '#f0fffd',
            border: 'rgba(87,87,87,0.08)',
          },
          brand: {
            background: '#e6fcfe',
            border: 'rgba(87,87,87,0.08)',
          },
          danger: {
            background: '#fcebeb',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative1: {
            background: '#e5f0ff',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative2: {
            background: '#fff4e5',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative3: {
            background: '#fdffe6',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative4: {
            background: '#e5f8ff',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative5: {
            background: '#e5fffd',
            border: 'rgba(87,87,87,0.08)',
          },
          neutral: {
            background: '#ffffff',
            border: 'rgba(87,87,87,0.08)',
          },
          success: {
            background: '#e5ffea',
            border: 'rgba(87,87,87,0.08)',
          },
          warning: {
            background: '#fbecc8',
            border: 'rgba(87,87,87,0.08)',
          },
        },
        inverse: {
          accent: {
            background: '#00665b',
            border: 'rgba(255,255,255,0.08)',
          },
          brand: {
            background: '#002623',
            border: 'rgba(255,255,255,0.08)',
          },
          danger: {
            background: '#660000',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative1: {
            background: '#004199',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative2: {
            background: '#995900',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative3: {
            background: '#8f9801',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative4: {
            background: '#004a66',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative5: {
            background: '#004d48',
            border: 'rgba(255,255,255,0.08)',
          },
          neutral: {
            background: '#030303',
            border: 'rgba(255,255,255,0.08)',
          },
          success: {
            background: '#00450b',
            border: 'rgba(255,255,255,0.08)',
          },
          warning: {
            background: '#614700',
            border: 'rgba(255,255,255,0.08)',
          },
        },
      },
      translucent: {
        default: {
          accent: {
            background: 'rgba(240,255,253,0.56)',
            border: 'rgba(87,87,87,0.08)',
          },
          brand: {
            background: 'rgba(230,252,254,0.56)',
            border: 'rgba(87,87,87,0.08)',
          },
          danger: {
            background: 'rgba(252,235,235,0.56)',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative1: {
            background: 'rgba(240,229,255,0.56)',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative2: {
            background: 'rgba(255,244,229,0.56)',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative3: {
            background: 'rgba(252,233,240,0.56)',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative4: {
            background: 'rgba(230,240,255,0.56)',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative5: {
            background: 'rgba(245,238,247,0.56)',
            border: 'rgba(87,87,87,0.08)',
          },
          neutral: {
            background: 'rgba(232,232,232,0.56)',
            border: 'rgba(87,87,87,0.08)',
          },
          success: {
            background: 'rgba(229,255,234,0.56)',
            border: 'rgba(87,87,87,0.08)',
          },
          warning: {
            background: 'rgba(244,198,90,0.48)',
            border: 'rgba(87,87,87,0.08)',
          },
        },
        inverse: {
          accent: {
            background: 'rgba(0,204,182,0.40)',
            border: 'rgba(255,255,255,0.08)',
          },
          brand: {
            background: 'rgba(4,93,103,0.16)',
            border: 'rgba(255,255,255,0.08)',
          },
          danger: {
            background: 'rgba(189,1,0,0.16)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative1: {
            background: 'rgba(0,108,255,0.32)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative2: {
            background: 'rgba(255,147,0,0.32)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative3: {
            background: 'rgba(205,218,1,0.32)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative4: {
            background: 'rgba(0,163,224,0.32)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative5: {
            background: 'rgba(0,191,179,0.32)',
            border: 'rgba(255,255,255,0.08)',
          },
          neutral: {
            background: 'rgba(23,27,38,0.40)',
            border: 'rgba(255,255,255,0.08)',
          },
          success: {
            background: 'rgba(2,120,21,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          warning: {
            background: 'rgba(120,88,0,0.48)',
            border: 'rgba(255,255,255,0.08)',
          },
        },
      },
      transparent: {
        default: {
          accent: {
            background: 'rgba(0,204,182,0.08)',
            border: 'rgba(87,87,87,0.08)',
          },
          brand: {
            background: 'rgba(230,252,254,0.08)',
            border: 'rgba(87,87,87,0.08)',
          },
          danger: {
            background: 'rgba(252,235,235,0.08)',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative1: {
            background: 'rgba(240,229,255,0.08)',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative2: {
            background: 'rgba(255,244,229,0.08)',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative3: {
            background: 'rgba(252,233,240,0.08)',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative4: {
            background: 'rgba(230,240,255,0.08)',
            border: 'rgba(87,87,87,0.08)',
          },
          decorative5: {
            background: 'rgba(245,238,247,0.08)',
            border: 'rgba(87,87,87,0.08)',
          },
          neutral: {
            background: 'rgba(255,255,255,0.08)',
            border: 'rgba(87,87,87,0.08)',
          },
          success: {
            background: 'rgba(229,255,234,0.04)',
            border: 'rgba(87,87,87,0.08)',
          },
          warning: {
            background: 'rgba(244,198,90,0.08)',
            border: 'rgba(87,87,87,0.08)',
          },
        },
        inverse: {
          accent: {
            background: 'rgba(0,204,182,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          brand: {
            background: 'rgba(4,93,103,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          danger: {
            background: 'rgba(189,1,0,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative1: {
            background: 'rgba(0,108,255,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative2: {
            background: 'rgba(255,147,0,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative3: {
            background: 'rgba(205,218,1,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative4: {
            background: 'rgba(0,163,224,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative5: {
            background: 'rgba(0,191,179,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          neutral: {
            background: 'rgba(87,87,87,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          success: {
            background: 'rgba(2,120,21,0.04)',
            border: 'rgba(255,255,255,0.08)',
          },
          warning: {
            background: 'rgba(240,179,35,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
        },
      },
    },
    effects: {
      default: {
        blur: {
          background: '48px',
        },
      },
    },
    layout: {
      default: {
        count: '12px',
        gutter: '16px',
        margin: '0',
      },
    },
    radius: {
      default: {
        default: '8px',
      },
      round: {
        default: '24px',
      },
      sharp: {
        default: '12px',
      },
    },
    sizing: {
      default: {
        border: '1px',
      },
    },
    spacing: {
      compact: {
        padding: '8px',
      },
      default: {
        padding: '16px',
      },
      spacious: {
        padding: '24px',
      },
    },
  },
  gridlines: {
    default: {
      color: {
        content: {
          enabled: '#4d4d4d',
        },
        grids: {
          enabled: '#808080',
        },
      },
      padding: {
        bottom: '8px',
        gap: '8px',
        left: '8px',
        right: '8px',
        top: '4px',
      },
    },
  },
  hero: {
    accent: {
      color: {
        content: {
          enabled: '#ffffff',
        },
        surface: {
          enabled: '#00ccb6',
          gradient: {
            stop1: '#045d67',
            stop2: '#00897a',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    brand: {
      color: {
        content: {
          enabled: '#ffffff',
        },
        surface: {
          enabled: '#045d67',
          gradient: {
            stop1: '#00403a',
            stop2: '#045d67',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    classic: {
      color: {
        content: {
          enabled: '#ffffff',
        },
        surface: {
          enabled: '#006cff',
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '16px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    inverse: {
      color: {
        content: {
          enabled: '#ffffff',
        },
        surface: {
          enabled: '#000000',
          gradient: {
            stop1: '#333333',
            stop2: '#444444',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    neutral: {
      color: {
        content: {
          enabled: '#3a3a3a',
        },
        surface: {
          enabled: '#f5f8f6',
          gradient: {
            stop1: '#00897a',
            stop2: '#f5f8f6',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
  },
  icon: {
    IDS: {
      color: {
        internalDesignBackground: '#575757',
      },
      sizing: {
        lg: {
          height: '40px',
          width: '40px',
        },
        lineHeight: {
          bodyDefault: '24px',
          bodySmall: '21px',
          caption: '20px',
          headline: '53px',
          subheadline: '35px',
          subtitle: '30px',
          title: '36px',
        },
        md: {
          height: '24px',
          width: '24px',
        },
        sm: {
          height: '20px',
          width: '20px',
        },
        xs: {
          height: '16px',
          width: '16px',
        },
      },
    },
    SLDS: {
      color: {
        internalDesignBackground: '#575757',
      },
      sizing: {
        lg: {
          height: '26px',
          width: '26px',
        },
        lineHeight: {
          bodyDefault: '24px',
          bodySmall: '21px',
          caption: '20px',
          headline: '53px',
          subheadline: '35px',
          subtitle: '30px',
          title: '36px',
        },
        md: {
          height: '24px',
          width: '24px',
        },
        sm: {
          height: '14px',
          width: '14px',
        },
        xs: {
          height: '10px',
          width: '10px',
        },
      },
    },
  },
  iconButton: {
    default: {
      color: {
        background: {
          disabled: 'rgba(4,93,103,0)',
          enabled: 'rgba(4,93,103,0)',
          filled: '#ffffff',
          focus: 'rgba(4,93,103,0.08)',
          hover: 'rgba(4,93,103,0.08)',
          pressed: 'rgba(4,93,103,0.16)',
          selected: '#045d67',
        },
        border: {
          disabled: 'rgba(148,148,148,0.48)',
          enabled: '#949494',
          focus: '#949494',
          hover: '#00403a',
          pressed: '#002623',
        },
        icon: {
          disabled: 'rgba(87,87,87,0.48)',
          enabled: '#575757',
          focus: '#00403a',
          hover: '#00403a',
          pressed: '#002623',
          selected: '#ffffff',
        },
        outline: '#001a17',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(189,1,0,0)',
          enabled: 'rgba(189,1,0,0)',
          filled: '#ffffff',
          focus: 'rgba(189,1,0,0.08)',
          hover: 'rgba(189,1,0,0.08)',
          pressed: 'rgba(189,1,0,0.16)',
          selected: '#bd0100',
        },
        border: {
          disabled: 'rgba(148,148,148,0.48)',
          enabled: '#949494',
          focus: '#949494',
          hover: '#990000',
          pressed: '#660000',
        },
        icon: {
          disabled: 'rgba(87,87,87,0.48)',
          enabled: '#575757',
          focus: '#990000',
          hover: '#990000',
          pressed: '#660000',
          selected: '#ffffff',
        },
        outline: '#001a17',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    onColor: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0)',
          enabled: 'rgba(255,255,255,0)',
          filled: '#3a3a3a',
          focus: 'rgba(255,255,255,0.08)',
          hover: 'rgba(255,255,255,0.08)',
          pressed: 'rgba(232,232,232,0.16)',
        },
        border: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        icon: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        outline: '#ffffff',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    onColorInverse: {
      color: {
        background: {
          disabled: 'rgba(87,87,87,0)',
          enabled: 'rgba(87,87,87,0)',
          filled: '#3a3a3a',
          focus: 'rgba(87,87,87,0.08)',
          hover: 'rgba(87,87,87,0.08)',
          pressed: 'rgba(87,87,87,0.16)',
        },
        border: {
          disabled: 'rgba(87,87,87,0.48)',
          enabled: '#575757',
          focus: '#575757',
          hover: '#444444',
          pressed: '#333333',
        },
        icon: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          focus: '#242424',
          hover: '#242424',
          pressed: '#030303',
        },
        outline: '#3a3a3a',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    toggle: {
      color: {
        background: {
          disabled: 'rgba(4,93,103,0)',
          enabled: 'rgba(4,93,103,0)',
          filled: '#ffffff',
          focus: 'rgba(4,93,103,0.08)',
          hover: 'rgba(4,93,103,0.08)',
          pressed: 'rgba(4,93,103,0.16)',
          selected: '#000000',
        },
        border: {
          disabled: '#696969',
          enabled: '#e8e8e8',
          focus: '#949494',
          hover: '#696969',
          pressed: '#575757',
        },
        icon: {
          disabled: 'rgba(87,87,87,0.48)',
          enabled: '#575757',
          focus: '#444444',
          hover: '#444444',
          pressed: '#333333',
          selected: '#ffffff',
        },
        outline: '#001a17',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
  },
  label: {
    default: {
      color: {
        asterisk: '#bd0100',
        optional: '#575757',
        text: '#3a3a3a',
      },
      spacing: {
        padding: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  list: {
    default: {
      color: {
        background: {
          inset: '#e8e8e8',
        },
        border: '#e8e8e8',
        scrollbar: 'rgba(87,87,87,0.16)',
      },
      radius: '12px',
      spacing: {
        padding: {
          compact: {
            basic: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            inset: {
              bottom: '8px',
              gap: '8px',
              left: '8px',
              right: '8px',
              top: '8px',
            },
            modal: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
          default: {
            basic: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            inset: {
              bottom: '16px',
              gap: '16px',
              left: '16px',
              right: '16px',
              top: '16px',
            },
            modal: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
      },
    },
  },
  listItem: {
    default: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#e8e8e8',
          hover: '#f7f7f7',
          pressed: '#dddddd',
        },
        border: {
          disabled: 'rgba(232,232,232,0.48)',
          enabled: '#e8e8e8',
          focus: '#c7c7c7',
          hover: '#dddddd',
          pressed: '#c7c7c7',
        },
        icon: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          focus: '#3a3a3a',
          hover: '#00403a',
          pressed: '#002623',
        },
        leadingIcon: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          focus: '#002623',
          hover: '#00403a',
          pressed: '#002623',
        },
        text: {
          label: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#002623',
            hover: '#00403a',
            pressed: '#002623',
          },
          sub: {
            disabled: 'rgba(87,87,87,0.48)',
            enabled: '#575757',
            focus: '#002623',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
        trailingIcon: {
          disabled: 'rgba(148,148,148,0.48)',
          enabled: '#949494',
          focus: '#002623',
          hover: '#00403a',
          pressed: '#002623',
        },
      },
      radius: {
        small: '0',
        standard: '0',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        small: {
          min: {
            height: '30px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '4px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
        standard: {
          min: {
            height: '48px',
            width: '64px',
          },
          padding: {
            bottom: '8px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '8px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#e8e8e8',
          hover: '#f7f7f7',
          pressed: '#dddddd',
        },
        border: {
          disabled: 'rgba(232,232,232,0.48)',
          enabled: '#e8e8e8',
          focus: '#c7c7c7',
          hover: '#dddddd',
          pressed: '#c7c7c7',
        },
        icon: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        leadingIcon: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#660000',
          hover: '#990000',
          pressed: '#660000',
        },
        text: {
          label: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#660000',
            hover: '#990000',
            pressed: '#660000',
          },
          sub: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#660000',
            hover: '#990000',
            pressed: '#660000',
          },
        },
        trailingIcon: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#660000',
          hover: '#990000',
          pressed: '#660000',
        },
      },
      radius: {
        small: '0',
        standard: '0',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        small: {
          min: {
            height: '30px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '4px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
        standard: {
          min: {
            height: '48px',
            width: '64px',
          },
          padding: {
            bottom: '8px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '8px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
      },
    },
  },
  menu: {
    default: {
      color: {
        background: {
          list: '#ffffff',
        },
      },
      spacing: {
        padding: {
          bottom: '0',
          gap: '8px',
          left: '0',
          list: {
            bottom: '8px',
            gap: '0',
            left: '0',
            right: '0',
            top: '8px',
          },
          right: '0',
          top: '0',
        },
      },
    },
  },
  modal: {
    default: {
      color: {
        body: {
          text: '#3a3a3a',
        },
        border: '#e8e8e8',
        colorBar: '#045d67',
        container: '#ffffff',
        header: {
          heading: '#3a3a3a',
          subheading: '#575757',
        },
        scrim: 'rgba(58,58,58,0.48)',
      },
      radius: {
        container: '12px',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    error: {
      color: {
        body: {
          text: '#3a3a3a',
        },
        border: '#e8e8e8',
        colorBar: '#bd0100',
        container: '#ffffff',
        header: {
          heading: '#3a3a3a',
          subheading: '#575757',
        },
        scrim: 'rgba(58,58,58,0.48)',
      },
      radius: {
        container: '12px',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '4px',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    success: {
      color: {
        body: {
          text: '#3a3a3a',
        },
        border: '#e8e8e8',
        colorBar: '#027815',
        container: '#ffffff',
        header: {
          heading: '#3a3a3a',
          subheading: '#575757',
        },
        scrim: 'rgba(58,58,58,0.48)',
      },
      radius: {
        container: '12px',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '4px',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    warning: {
      color: {
        body: {
          text: '#3a3a3a',
        },
        border: '#e8e8e8',
        colorBar: '#f4c65a',
        container: '#ffffff',
        header: {
          heading: '#3a3a3a',
          subheading: '#575757',
        },
        scrim: 'rgba(58,58,58,0.48)',
      },
      radius: {
        container: '12px',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '4px',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  navItem: {
    inverse: {
      color: {
        background: {
          control: {
            disabled: 'rgba(23,27,38,0.24)',
            enabled: 'rgba(23,27,38,0.40)',
            focus: 'rgba(23,27,38,0.40)',
            hover: 'rgba(4,93,103,0.40)',
            pressed: 'rgba(4,93,103,0.56)',
          },
          default: {
            disabled: 'rgba(68,68,68,0)',
            enabled: 'rgba(68,68,68,0)',
            focus: 'rgba(68,68,68,0)',
            hover: 'rgba(68,68,68,0.16)',
            pressed: 'rgba(23,27,38,0.40)',
          },
          insetGroup: 'rgba(232,232,232,0.08)',
          selected: {
            enabled: 'rgba(255,255,255,0.08)',
            focus: 'rgba(255,255,255,0.08)',
            hover: 'rgba(232,232,232,0.16)',
            pressed: 'rgba(232,232,232,0.16)',
          },
        },
        border: {
          default: 'rgba(148,148,148,0.16)',
          focus: '#e6fcfe',
          selected: 'rgba(23,27,38,0.40)',
        },
        content: {
          control: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#e6fcfe',
            pressed: '#cef8fd',
          },
          default: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#cef8fd',
            pressed: '#a7f3fc',
          },
          selected: {
            enabled: '#e6fcfe',
            focus: '#e6fcfe',
            hover: '#cef8fd',
            pressed: '#a7f3fc',
          },
        },
      },
      radius: {
        control: '9999px',
        insetGroup: '8px',
      },
    },
    neutral: {
      color: {
        background: {
          control: {
            disabled: 'rgba(255,255,255,0.40)',
            enabled: 'rgba(255,255,255,0.72)',
            focus: 'rgba(255,255,255,0.72)',
            hover: 'rgba(230,252,254,0.72)',
            pressed: 'rgba(230,252,254,0.88)',
          },
          default: {
            disabled: 'rgba(246,247,251,0)',
            enabled: 'rgba(245,248,246,0)',
            focus: 'rgba(245,248,246,0)',
            hover: 'rgba(245,248,246,0.16)',
            pressed: 'rgba(245,248,246,0.40)',
          },
          insetGroup: 'rgba(148,148,148,0.08)',
          selected: {
            enabled: 'rgba(148,148,148,0.08)',
            focus: 'rgba(148,148,148,0.08)',
            hover: 'rgba(148,148,148,0.16)',
            pressed: 'rgba(148,148,148,0.16)',
          },
        },
        border: {
          default: 'rgba(148,148,148,0.08)',
          focus: '#001a17',
          selected: 'rgba(232,232,232,0.40)',
        },
        content: {
          control: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#00403a',
            pressed: '#002623',
          },
          default: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
          selected: {
            enabled: '#00403a',
            focus: '#00403a',
            hover: '#002623',
            pressed: '#002623',
          },
        },
      },
      radius: {
        control: '9999px',
        insetGroup: '8px',
      },
    },
  },
  navbar: {
    accent: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
            selected: '#ffffff',
          },
          text: {
            enabled: '#ffffff',
          },
        },
        notificationBell: '#575757',
        outline: {
          focus: '#f0fffd',
        },
        surface: {
          background: {
            enabled: '#00897a',
            gradient: {
              stop1: '#045d67',
              stop2: '#00897a',
            },
            overlay: 'rgba(0,204,182,0.16)',
          },
          item: {
            disabled: 'rgba(0,204,182,0)',
            enabled: 'rgba(0,204,182,0)',
            focus: 'rgba(0,204,182,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.12)',
            selected: 'rgba(255,255,255,0.18)',
          },
        },
        wave: {
          five: '#045d67',
          four: '#00ccb6',
          one: '#ffffff',
          three: '#cdda01',
          two: '#333333',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    brand: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
            selected: '#ffffff',
          },
          text: {
            enabled: '#ffffff',
          },
        },
        notificationBell: '#575757',
        outline: {
          focus: '#e6fcfe',
        },
        surface: {
          background: {
            enabled: '#00403a',
            gradient: {
              stop1: '#00403a',
              stop2: '#045d67',
            },
            overlay: 'rgba(4,93,103,0.16)',
          },
          item: {
            disabled: 'rgba(4,93,103,0)',
            enabled: 'rgba(4,93,103,0)',
            focus: 'rgba(4,93,103,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.12)',
            selected: 'rgba(255,255,255,0.18)',
          },
        },
        wave: {
          five: '#00ccb6',
          four: '#045d67',
          one: '#ffffff',
          three: '#00bfb3',
          two: '#030303',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    classic: {
      color: {
        border: {
          sidebarItem: 'rgba(37,0,86,0.12)',
        },
        content: {
          item: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
            selected: '#ffffff',
          },
          text: {
            enabled: '#ffffff',
          },
        },
        notificationBell: '#575757',
        outline: {
          focus: '#e6fcfe',
        },
        surface: {
          background: {
            enabled: '#006cff',
            gradient: {
              stop1: '#006cff',
              stop2: '#0076ae',
            },
            overlay: 'rgba(0,108,255,0.08)',
          },
          item: {
            disabled: 'rgba(232,232,232,0)',
            enabled: 'rgba(232,232,232,0)',
            focus: 'rgba(232,232,232,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.12)',
            selected: 'rgba(255,255,255,0.18)',
          },
        },
        wave: {
          five: '#ffffff',
          four: '#ffffff',
          one: '#ffffff',
          three: '#ffffff',
          two: '#333333',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '29px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    inverse: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#e8e8e8',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
            selected: '#ffffff',
          },
          text: {
            enabled: '#ffffff',
          },
        },
        notificationBell: '#575757',
        outline: {
          focus: '#e6fcfe',
        },
        surface: {
          background: {
            enabled: '#242424',
            gradient: {
              stop1: '#333333',
              stop2: '#444444',
            },
            overlay: 'rgba(87,87,87,0.16)',
          },
          item: {
            disabled: 'rgba(232,232,232,0)',
            enabled: 'rgba(232,232,232,0)',
            focus: 'rgba(232,232,232,0)',
            hover: 'rgba(230,230,230,0.08)',
            pressed: 'rgba(230,230,230,0.12)',
            selected: 'rgba(230,230,230,0.18)',
          },
        },
        wave: {
          five: '#00897a',
          four: '#00403a',
          one: '#045d67',
          three: 'rgba(0,191,179,0.32)',
          two: '#030303',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    neutral: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
            selected: '#030303',
          },
          text: {
            enabled: '#3a3a3a',
          },
        },
        notificationBell: '#575757',
        outline: {
          focus: '#00403a',
        },
        surface: {
          background: {
            enabled: '#f5f8f6',
            gradient: {
              stop1: '#00897a',
              stop2: '#f5f8f6',
            },
            overlay: 'rgba(232,232,232,0.16)',
          },
          item: {
            disabled: 'rgba(87,87,87,0)',
            enabled: 'rgba(87,87,87,0)',
            focus: 'rgba(87,87,87,0)',
            hover: 'rgba(77,77,77,0.08)',
            pressed: 'rgba(77,77,77,0.12)',
            selected: 'rgba(77,77,77,0.18)',
          },
        },
        wave: {
          five: '#dbfffb',
          four: '#a7f3fc',
          one: '#045d67',
          three: 'rgba(205,218,1,0.32)',
          two: 'rgba(87,87,87,0.16)',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
  },
  pagination: {
    default: {
      color: {
        barBackground: {
          enabled: '#f5f8f6',
        },
        barBorder: {
          enabled: '#e8e8e8',
        },
        label: {
          enabled: '#575757',
        },
        outline: '#001a17',
      },
      padding: {
        multiPage: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        pagination: {
          bottom: '10px',
          gap: '0',
          left: '16px',
          right: '16px',
          top: '10px',
        },
        select: {
          bottom: '0',
          gap: '8px',
          left: '0',
          right: '0',
          top: '0',
        },
        singlePage: {
          bottom: '0',
          gap: '0',
          left: '4px',
          right: '4px',
          top: '0',
        },
        tabs: {
          bottom: '0',
          gap: '8px',
          left: '0',
          right: '0',
          top: '0',
        },
        textField: {
          left: '4px',
        },
      },
      radius: {
        radius: '0',
      },
    },
  },
  passwordInput: {
    default: {
      spacing: {
        bottom: '0',
        gap: '4px',
        left: '16px',
        right: '0',
        top: '0',
      },
    },
  },
  progressIndicator: {
    default: {
      circular: {
        color: {
          indicator: {
            live: '#045d67',
            track: '#e8e8e8',
          },
          solid: {
            background: '#030303',
            indicator: {
              live: '#a7f3fc',
              track: '#696969',
            },
            text: '#ffffff',
          },
          transparent: {
            background: 'rgba(255,255,255,0)',
            indicator: {
              live: '#045d67',
              track: '#dddddd',
            },
            text: '#3a3a3a',
          },
        },
        padding: {
          container: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
          content: {
            bottom: '24px',
            gap: '8px',
            left: '24px',
            right: '24px',
            top: '24px',
          },
          indicator: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
        },
        radius: {
          container: '12px',
          live: '9999px',
          track: '9999px',
        },
      },
      ids: {
        color: {
          indicator: {
            neutral: '#575757',
            oval1: '#00a3e0',
            oval2: '#00bfb3',
            oval3: '#cdda01',
            oval4: '#ff9300',
          },
          solid: {
            background: '#030303',
            text: '#ffffff',
          },
          transparent: {
            background: 'rgba(255,255,255,0)',
            text: '#3a3a3a',
          },
        },
        padding: {
          container: {
            bottom: '24px',
            gap: '8px',
            left: '24px',
            right: '24px',
            top: '24px',
          },
        },
        radius: {
          container: '12px',
        },
      },
      wrapper: {
        color: {
          scrim: {
            blurred: 'rgba(255,255,255,0.72)',
            solid: '#ffffff',
          },
        },
      },
    },
  },
  progressIndicatorDesignOnly: {
    default: {
      container: 'transparent',
      mode: 'default',
    },
  },
  radio: {
    default: {
      border: {
        control: '1px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(4,93,103,0.48)',
              enabled: '#045d67',
              focus: '#045d67',
              hover: '#00403a',
              pressed: '#002623',
            },
            unselected: {
              disabled: 'rgba(4,93,103,0)',
              enabled: 'rgba(4,93,103,0)',
              focus: 'rgba(4,93,103,0)',
              hover: 'rgba(4,93,103,0.08)',
              pressed: 'rgba(4,93,103,0.16)',
            },
          },
          border: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
            focus: '#949494',
            hover: '#00403a',
            pressed: '#002623',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        help: {
          enabled: '#575757',
        },
        label: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          focus: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
        outline: '#001a17',
      },
      radius: {
        control: '9999px',
        focus: {
          label: '12px',
          noLabel: '9999px',
        },
      },
      sizing: {
        control: {
          container: {
            height: '24px',
            width: '24px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
        width: '16px',
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
            small: {
              gap: '12px',
              padding: '8px',
            },
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    error: {
      border: {
        control: '2px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(189,1,0,0.48)',
              enabled: '#bd0100',
              focus: '#bd0100',
              hover: '#990000',
              pressed: '#660000',
            },
            unselected: {
              disabled: 'rgba(189,1,0,0)',
              enabled: 'rgba(189,1,0,0)',
              focus: 'rgba(189,1,0,0)',
              hover: 'rgba(189,1,0,0.08)',
              pressed: 'rgba(189,1,0,0.16)',
            },
          },
          border: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#bd0100',
            hover: '#990000',
            pressed: '#660000',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        help: {
          enabled: '#bd0100',
        },
        label: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          focus: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
        outline: '#001a17',
      },
      radius: {
        control: '9999px',
        focus: {
          label: '12px',
          noLabel: '9999px',
        },
      },
      sizing: {
        control: {
          container: {
            height: '24px',
            width: '24px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
        width: '16px',
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
            small: {
              gap: '12px',
              padding: '8px',
            },
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  responsiveNavbar: {
    lg: {
      spacing: {
        sm: '4px',
      },
      width: {
        max: '1535px',
        min: '1200px',
      },
    },
    md: {
      spacing: {
        sm: '4px',
      },
      width: {
        max: '1199px',
        min: '900px',
      },
    },
    sm: {
      spacing: {
        sm: '4px',
      },
      width: {
        max: '899px',
        min: '600px',
      },
    },
    xl: {
      spacing: {
        sm: '8px',
      },
      width: {
        max: '2000px',
        min: '1536px',
      },
    },
    xs: {
      spacing: {
        sm: '2px',
      },
      width: {
        max: '599px',
        min: '320px',
      },
    },
  },
  segmentedControl: {
    default: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(230,252,254,0.48)',
            enabled: '#a7f3fc',
            hover: '#cef8fd',
            pressed: '#e6fcfe',
          },
          unselected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            hover: '#e6fcfe',
            pressed: '#cef8fd',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
            enabledHover: '#696969',
            enabledPressed: '#575757',
          },
          unselected: '#949494',
        },
        content: {
          selected: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#002623',
            hover: '#002623',
            pressed: '#045d67',
          },
          unselected: {
            disabled: 'rgba(87,87,87,0.48)',
            enabled: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
        focus: {
          fill: 'rgba(255,255,255,0)',
          outline: '#001a17',
          shadow: '#e6fcfe',
        },
      },
      radius: {
        container: '0',
        group: '9999px',
      },
      sizing: {
        small: {
          minHeight: '40px',
          minWidth: '40px',
        },
        standard: {
          minHeight: '48px',
          minWidth: '48px',
        },
      },
      spacing: {
        small: {
          gap: '4px',
          horizontalPadding: '24px',
        },
        standard: {
          gap: '8px',
          horizontalPadding: '24px',
        },
      },
    },
    inverse: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            hover: '#f7f7f7',
            pressed: '#e8e8e8',
          },
          unselected: {
            disabled: 'rgba(87,87,87,0)',
            enabled: 'rgba(87,87,87,0)',
            hover: 'rgba(87,87,87,0.40)',
            pressed: 'rgba(87,87,87,0.56)',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(232,232,232,0.48)',
            enabled: '#e8e8e8',
            enabledHover: '#dddddd',
            enabledPressed: '#c7c7c7',
          },
          unselected: '#e8e8e8',
        },
        content: {
          selected: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
          unselected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        focus: {
          fill: 'rgba(255,255,255,0)',
          outline: '#001a17',
          shadow: '#e6fcfe',
        },
      },
      radius: {
        container: '0',
        group: '9999px',
      },
      sizing: {
        small: {
          minHeight: '40px',
          minWidth: '40px',
        },
        standard: {
          minHeight: '48px',
          minWidth: '48px',
        },
      },
      spacing: {
        small: {
          gap: '4px',
          horizontalPadding: '24px',
        },
        standard: {
          gap: '8px',
          horizontalPadding: '24px',
        },
      },
    },
    neutral: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
          unselected: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0.40)',
            pressed: 'rgba(232,232,232,0.56)',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
            enabledHover: '#696969',
            enabledPressed: '#575757',
          },
          unselected: '#575757',
        },
        content: {
          selected: {
            disabled: 'rgba(206,248,253,0.48)',
            enabled: '#a7f3fc',
            hover: '#cef8fd',
            pressed: '#e6fcfe',
          },
          unselected: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
        },
        focus: {
          fill: 'rgba(255,255,255,0)',
          outline: '#001a17',
          shadow: '#e6fcfe',
        },
      },
      radius: {
        container: '0',
        group: '9999px',
      },
      sizing: {
        small: {
          minHeight: '40px',
          minWidth: '40px',
        },
        standard: {
          minHeight: '48px',
          minWidth: '48px',
        },
      },
      spacing: {
        small: {
          gap: '4px',
          horizontalPadding: '24px',
        },
        standard: {
          gap: '8px',
          horizontalPadding: '24px',
        },
      },
    },
  },
  select: {
    default: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#f7f7f7',
          pressed: '#ffffff',
        },
        border: {
          disabled: 'rgba(148,148,148,0.48)',
          enabled: '#949494',
          focus: '#949494',
          hover: '#696969',
          pressed: '#045d67',
        },
        help: {
          disabled: 'rgba(87,87,87,0.48)',
          enabled: '#575757',
          focus: '#575757',
          hover: '#444444',
          pressed: '#333333',
        },
        input: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          focus: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
        label: {
          disabled: 'rgba(58,58,58,0.48)',
          focus: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
      },
      outline: '#001a17',
      radius: {
        small: '12px',
        standard: '12px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '40px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            right: '8px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '48px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            right: '8px',
            top: '4px',
          },
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#f7f7f7',
          pressed: '#ffffff',
        },
        border: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        help: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        input: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          focus: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
        label: {
          disabled: 'rgba(58,58,58,0.48)',
          focus: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
      },
      outline: '#001a17',
      radius: {
        small: '12px',
        standard: '12px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '40px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            right: '8px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '48px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            right: '8px',
            top: '4px',
          },
        },
      },
    },
  },
  slider: {
    default: {
      color: {
        bar: {
          disabled: 'rgba(4,93,103,0.48)',
          enabled: '#045d67',
        },
        handle: {
          border: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
            focus: '#949494',
            hover: '#045d67',
            pressed: '#045d67',
          },
          fill: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        helpAndValueText: {
          default: '#3a3a3a',
          disabled: 'rgba(58,58,58,0.48)',
        },
        helpText: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          focus: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
        label: {
          disabled: 'rgba(58,58,58,0.48)',
        },
        tickMark: {
          bar: {
            default: '#ffffff',
            disabled: 'rgba(255,255,255,0.48)',
          },
          track: {
            default: '#045d67',
            disabled: 'rgba(4,93,103,0.48)',
          },
        },
        track: {
          border: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
          },
          disabled: 'rgba(232,232,232,0.48)',
          enabled: '#e8e8e8',
          fill: {
            disabled: 'rgba(245,248,246,0.48)',
            enabled: '#f5f8f6',
          },
        },
      },
      radius: {
        handle: '9999px',
        trackBar: '9999px',
      },
      shadow: {
        blur: '0',
        hover: 'rgba(5,87,213,0.10)',
        'hover-spread': '6px',
        hoverSpread: '6px',
        pressed: 'rgba(5,87,213,0.10)',
        'pressed-spread': '12px',
        pressedSpread: '12px',
        x: '0',
        y: '0',
      },
      sizing: {
        standard: {
          handle: {
            height: '24px',
            width: '24px',
          },
          track: {
            height: '8px',
          },
        },
        xl: {
          handle: {
            height: '40px',
            width: '40px',
          },
          track: {
            height: '12px',
          },
        },
      },
      spacing: {
        numberPicker: '0',
        standard: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
        xl: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
      },
    },
    error: {
      color: {
        bar: {
          disabled: 'rgba(232,232,232,0.48)',
          enabled: '#bd0100',
        },
        handle: {
          border: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#bd0100',
            focus: '#949494',
            hover: '#bd0100',
            pressed: '#bd0100',
          },
          fill: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        helpAndValueText: {
          default: '#bd0100',
          disabled: 'rgba(189,1,0,0.48)',
        },
        helpText: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        label: {
          disabled: 'rgba(58,58,58,0.48)',
        },
        tickMark: {
          bar: {
            default: '#ffffff',
            disabled: 'rgba(255,255,255,0.48)',
          },
          track: {
            default: '#045d67',
            disabled: 'rgba(4,93,103,0.48)',
          },
        },
        track: {
          border: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#bd0100',
          },
          disabled: 'rgba(232,232,232,0.48)',
          enabled: '#e8e8e8',
          fill: {
            disabled: 'rgba(245,248,246,0.48)',
            enabled: '#f5f8f6',
          },
        },
      },
      radius: {
        handle: '9999px',
        trackBar: '9999px',
      },
      shadow: {
        blur: '0',
        hover: 'rgba(189,1,0,0.10)',
        'hover-spread': '6px',
        hoverSpread: '6px',
        pressed: 'rgba(189,1,0,0.10)',
        'pressed-spread': '12px',
        pressedSpread: '12px',
        x: '0',
        y: '0',
      },
      sizing: {
        standard: {
          handle: {
            height: '24px',
            width: '24px',
          },
          track: {
            height: '8px',
          },
        },
        xl: {
          handle: {
            height: '40px',
            width: '40px',
          },
          track: {
            height: '12px',
          },
        },
      },
      spacing: {
        numberPicker: '0',
        standard: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
        xl: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
      },
    },
  },
  splitButton: {
    default: {
      color: {
        border: {
          primary: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            transparent: 'rgba(255,255,255,0)',
          },
          secondary: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
          },
          tertiary: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            transparent: 'rgba(255,255,255,0)',
          },
        },
      },
      padding: {
        gap: '0',
      },
      radius: {
        button1: '0',
        button2: '0',
        button3: '0',
        button4: '0',
        buttonGroup: '9999px',
      },
    },
  },
  stepper: {
    default: {
      color: {
        boxBorder: {
          disabled: 'rgba(232,232,232,0.48)',
          enabled: '#e8e8e8',
          focus: '#e8e8e8',
          hover: '#dddddd',
          pressed: '#c7c7c7',
        },
        completed: {
          box: {
            disabled: 'rgba(245,248,246,0.48)',
            enabled: '#f5f8f6',
            focus: '#f5f8f6',
            hover: '#edf2ef',
            pressed: '#e4ece7',
          },
          divider: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
          },
          icon: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
          path: {
            enabled: '#045d67',
          },
          text: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
        },
        focusBorder: '#001a17',
        inProgress: {
          box: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#edf2ef',
            pressed: '#e4ece7',
          },
          icon: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
          text: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
        },
        incomplete: {
          box: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#f7f7f7',
            pressed: '#e8e8e8',
          },
          divider: {
            disabled: 'rgba(87,87,87,0.48)',
            enabled: '#575757',
          },
          icon: {
            disabled: 'rgba(87,87,87,0.48)',
            enabled: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
          path: {
            enabled: '#c7c7c7',
          },
          text: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
        },
      },
      radius: {
        container: '12px',
        path: '9999px',
        pathStart: '9999px',
      },
      sizing: {
        box: {
          'max-height': '480px',
          'max-width': '480px',
          'min-height': '64px',
          'min-width': '64px',
        },
        horizontal: {
          max: {
            width: '160px',
          },
        },
        text: {
          max: {
            width: '480px',
          },
          min: {
            height: '48px',
            width: '48px',
          },
        },
      },
      spacing: {
        box: {
          bottom: '8px',
          gap: '8px',
          left: '12px',
          right: '16px',
          text: {
            bottom: '4px',
            top: '4px',
          },
          top: '8px',
        },
        boxGroup: {
          gap: '8px',
        },
        horizontal: {
          gap: '4px',
          gapNegative: '-8px',
          text: {
            side: '16px',
          },
        },
        vertical: {
          gap: '8px',
          path: {
            gap: '2px',
          },
          text: {
            bottom: '8px',
            right: '8px',
            top: '4px',
          },
        },
      },
    },
  },
  switch: {
    default: {
      color: {
        helpText: '#3a3a3a',
        off: {
          background: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
            focus: '#949494',
            hover: '#696969',
            pressed: '#575757',
          },
          handle: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        on: {
          background: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            focus: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
          handle: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        outline: '#001a17',
      },
      radius: {
        container: '9999px',
        handle: '9999px',
      },
      sizing: {
        small: {
          switch: {
            height: '24px',
            width: '48px',
          },
        },
        standard: {
          switch: {
            height: '40px',
            width: '64px',
          },
        },
      },
      spacing: {
        small: {
          padding: {
            bottom: '4px',
            left: '4px',
            right: '4px',
            switchGap: '8px',
            textGap: '4px',
            top: '4px',
          },
        },
        standard: {
          padding: {
            bottom: '4px',
            left: '4px',
            right: '4px',
            switchGap: '8px',
            textGap: '4px',
            top: '4px',
          },
        },
      },
    },
  },
  table: {
    default: {
      background: '#ffffff',
      border: {
        color: '#e8e8e8',
        colorFrozen: '#575757',
        radius: '12px',
        stroke: '1px',
      },
      shadow: {
        blur: '16px',
        color: 'rgba(87,87,87,0.08)',
        default: {
          blur: '16px',
          color: 'rgba(87,87,87,0.08)',
          spread: '0',
          x: '0',
          y: '4px',
        },
        frozen: {
          blur: '20px',
          color: 'rgba(87,87,87,0.16)',
          spread: '0',
          x: '8px',
          y: '0',
        },
        spread: '0',
        x: '0',
        y: '4px',
      },
      shadowFrozen: {
        blur: '20px',
        color: 'rgba(87,87,87,0.16)',
        spread: '0',
        x: '8px',
        y: '0',
      },
      tableCell: {
        border: {
          control: {
            color: {
              editable: '#c7c7c7',
              enabled: '#e8e8e8',
              hover: '#dddddd',
            },
            stroke: '1px',
          },
          head: {
            color: {
              enabled: '#e8e8e8',
              hover: '#dddddd',
              selected: '#e8e8e8',
            },
            stroke: '1px',
          },
          text: {
            color: {
              editable: '#c7c7c7',
              enabled: '#e8e8e8',
              hover: '#dddddd',
              selected: '#045d67',
            },
            stroke: '1px',
          },
          textSelected: {
            stroke: '1px',
          },
        },
        color: {
          control: {
            background: {
              editable: '#f5f8f6',
              enabled: '#ffffff',
              hover: '#e6fcfe',
            },
            label: {
              editable: '#030303',
              enabled: '#3a3a3a',
              hover: '#242424',
            },
          },
          head: {
            background: {
              enabled: '#f5f8f6',
              hover: '#edf2ef',
              selected: '#f5f8f6',
            },
            icon: {
              enabled: '#3a3a3a',
              hover: '#045d67',
            },
            label: {
              enabled: '#3a3a3a',
              hover: '#242424',
              selected: '#030303',
            },
          },
          text: {
            background: {
              editable: '#f5f8f6',
              enabled: '#ffffff',
              hover: '#e6fcfe',
              selected: '#cef8fd',
            },
            label: {
              editable: '#030303',
              enabled: '#3a3a3a',
              hover: '#242424',
              selected: '#00403a',
            },
          },
        },
        minHeight: '48px',
        padding: {
          control: {
            firstChild: '8px',
            gap: '8px',
            horizontal: '4px',
            lastChild: '8px',
            vertical: '4px',
          },
          head: {
            firstChild: '12px',
            gap: '4px',
            horizontal: '4px',
            lastChild: '12px',
            vertical: '12px',
          },
          text: {
            firstChild: '8px',
            gap: '8px',
            horizontal: '4px',
            lastChild: '8px',
            vertical: '12px',
          },
        },
      },
      tableRowExpanded: {
        color: {
          background: '#f5f8f6',
          border: '#e8e8e8',
          label: '#3a3a3a',
        },
        padding: {
          editTop: '16px',
          gap: '32px',
          horizontal: '24px',
          vertical: '8px',
        },
      },
      tableToolbar: {
        color: {
          background: '#ffffff',
          label: '#3a3a3a',
        },
        padding: {
          gap: '8px',
          horizontal: '16px',
          vertical: '16px',
        },
      },
    },
  },
  tabs: {
    default: {
      color: {
        background: {
          box: {
            disabled: 'rgba(245,248,246,0.48)',
            enabled: '#f5f8f6',
            focus: '#f5f8f6',
            hover: '#edf2ef',
            pressed: '#e4ece7',
          },
          disabled: 'rgba(255,255,255,0)',
          enabled: 'rgba(255,255,255,0)',
          focus: 'rgba(255,255,255,0)',
          hover: '#edf2ef',
          pressed: '#e4ece7',
        },
        border: {
          disabled: 'rgba(232,232,232,0.48)',
          enabled: '#e8e8e8',
          focus: '#e8e8e8',
          hover: '#dddddd',
          nested: 'rgba(255,255,255,0)',
          pressed: '#c7c7c7',
          selected: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            focus: '#001a17',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
        icon: {
          disabled: 'rgba(87,87,87,0.48)',
          enabled: '#575757',
          focus: '#575757',
          hover: '#444444',
          pressed: '#333333',
          selected: {
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
        },
        label: {
          disabled: 'rgba(87,87,87,0.48)',
          enabled: '#575757',
          focus: '#575757',
          hover: '#444444',
          pressed: '#333333',
          selected: {
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
            sublabel: '#575757',
          },
        },
        outline: {
          focus: '#001a17',
        },
      },
      radius: {
        horizontal: {
          bl: '0',
          bottomLeft: '0',
          bottomRight: '0',
          br: '0',
          tl: '4px',
          topLeft: '4px',
          topRight: '4px',
          tr: '4px',
        },
        vertical: {
          bl: '4px',
          bottomLeft: '4px',
          bottomRight: '0',
          br: '0',
          tl: '4px',
          topLeft: '4px',
          topRight: '0',
          tr: '0',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        min: {
          height: '40px',
          width: '40px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        tabList: {
          box: {
            bottom: '0',
            gap: '4px',
            left: '0',
            right: '0',
            top: '0',
          },
          line: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
        },
      },
    },
  },
  tag: {
    default: {
      color: {
        background: {
          default: {
            accent: '#00ccb6',
            brand: '#045d67',
            danger: '#bd0100',
            decorative1: '#006cff',
            decorative2: '#ff9300',
            decorative3: '#cdda01',
            decorative4: '#00a3e0',
            decorative5: '#00bfb3',
            neutral: '#3a3a3a',
            success: '#027815',
            warning: '#f0b323',
          },
          inverse: {
            accent: '#f0fffd',
            brand: '#e6fcfe',
            danger: '#fcebeb',
            decorative1: '#e5f0ff',
            decorative2: '#fff4e5',
            decorative3: '#fdffe6',
            decorative4: '#e5f8ff',
            decorative5: '#e5fffd',
            neutral: '#e8e8e8',
            success: '#e5ffea',
            warning: '#fbecc8',
          },
        },
        content: {
          accent: '#00ccb6',
          brand: '#045d67',
          danger: '#bd0100',
          decorative1: '#004199',
          decorative2: '#995900',
          decorative3: '#8f9801',
          decorative4: '#004a66',
          decorative5: '#004d48',
          neutral: '#ffffff',
          neutralInverse: '#3a3a3a',
          success: '#027815',
          warning: '#785800',
        },
        icon: '#ffffff',
        label: '#ffffff',
      },
      radius: '4px',
      sizing: {
        icon: {
          height: '12px',
          width: '12px',
        },
      },
      spacing: {
        min: {
          height: '20px',
          width: '20px',
        },
        padding: {
          bottom: '1px',
          gap: '4px',
          icon: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
          left: '8px',
          right: '8px',
          top: '0',
        },
      },
    },
  },
  textArea: {
    default: {
      min: {
        minHeight: '56px',
        minWidth: '112px',
      },
    },
    error: {
      min: {
        minHeight: '56px',
        minWidth: '112px',
      },
    },
  },
  textField: {
    default: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        border: {
          disabled: 'rgba(148,148,148,0.48)',
          enabled: '#949494',
          focus: '#045d67',
          hover: '#045d67',
          pressed: '#00403a',
        },
        help: {
          disabled: 'rgba(87,87,87,0.48)',
          enabled: '#575757',
          focus: '#575757',
          hover: '#444444',
          pressed: '#333333',
        },
        input: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          focus: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
        label: {
          disabled: 'rgba(58,58,58,0.48)',
          focus: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
        outline: '#001a17',
        placeholder: '#696969',
      },
      radius: {
        small: '12px',
        standard: '12px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '40px',
            width: '48px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            leftSldsIcon: '28px',
            right: '8px',
            rightSldsIcon: '24px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '48px',
            width: '48px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            leftSldsIcon: '36px',
            right: '8px',
            rightSldsIcon: '28px',
            top: '4px',
          },
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        border: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#660000',
          hover: '#990000',
          pressed: '#660000',
        },
        help: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        input: {
          disabled: 'rgba(58,58,58,0.48)',
          enabled: '#3a3a3a',
          focus: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
        label: {
          disabled: 'rgba(58,58,58,0.48)',
          focus: '#3a3a3a',
          hover: '#242424',
          pressed: '#030303',
        },
        outline: '#001a17',
        placeholder: '#696969',
      },
      radius: {
        small: '12px',
        standard: '12px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '40px',
            width: '48px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            leftSldsIcon: '28px',
            right: '8px',
            rightSldsIcon: '24px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '48px',
            width: '48px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            leftSldsIcon: '36px',
            right: '8px',
            rightSldsIcon: '28px',
            top: '4px',
          },
        },
      },
    },
  },
  textLink: {
    default: {
      color: {
        disabled: {
          icon: 'rgba(4,93,103,0.48)',
          text: 'rgba(4,93,103,0.48)',
        },
        enabled: {
          icon: '#045d67',
          text: '#045d67',
        },
        focus: {
          icon: '#045d67',
          text: '#045d67',
        },
        hover: {
          icon: '#00403a',
          text: '#00403a',
        },
        outline: '#001a17',
        pressed: {
          icon: '#002623',
          text: '#002623',
        },
      },
      radius: {
        small: '12px',
        standard: '12px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        padding: {
          small: {
            gap: '4px',
          },
          standard: {
            gap: '4px',
          },
        },
      },
    },
  },
  timePicker: {
    default: {
      color: {
        background: {
          now: '#f5f8f6',
        },
        border: {
          root: {
            disabled: 'rgba(148,148,148,0.48)',
            enabled: '#949494',
          },
        },
        text: {
          readOnly: '#575757',
        },
      },
    },
  },
  toast: {
    default: {
      color: {
        background: '#3a3a3a',
        border: 'rgba(255,255,255,0)',
        icon: '#ffffff',
        iconButton: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focused: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(232,232,232,0.16)',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focused: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#ffffff',
        },
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: '#a7f3fc',
            text: '#a7f3fc',
          },
          enabled: {
            icon: '#a7f3fc',
            text: '#a7f3fc',
          },
          focused: {
            icon: '#a7f3fc',
            text: '#a7f3fc',
          },
          hover: {
            icon: '#cef8fd',
            text: '#cef8fd',
          },
          outline: '#a7f3fc',
          pressed: {
            icon: '#e6fcfe',
            text: '#e6fcfe',
          },
        },
      },
      radius: '12px',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
    error: {
      color: {
        background: '#bd0100',
        border: 'rgba(255,255,255,0)',
        icon: '#ffffff',
        iconButton: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focused: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(232,232,232,0.16)',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focused: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#ffffff',
        },
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          enabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          focused: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          hover: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          outline: '#ffffff',
          pressed: {
            icon: '#ffffff',
            text: '#ffffff',
          },
        },
      },
      radius: '12px',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
    success: {
      color: {
        background: '#027815',
        border: 'rgba(255,255,255,0)',
        icon: '#ffffff',
        iconButton: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focused: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(232,232,232,0.16)',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focused: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#ffffff',
        },
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          enabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          focused: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          hover: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          outline: '#ffffff',
          pressed: {
            icon: '#ffffff',
            text: '#ffffff',
          },
        },
      },
      radius: '12px',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
    warning: {
      color: {
        background: '#926b00',
        border: 'rgba(255,255,255,0)',
        icon: '#ffffff',
        iconButton: {
          background: {
            disabled: 'rgba(87,87,87,0)',
            enabled: 'rgba(87,87,87,0)',
            focused: 'rgba(87,87,87,0)',
            hover: 'rgba(87,87,87,0.08)',
            pressed: 'rgba(87,87,87,0.16)',
          },
          icon: {
            disabled: '#3a3a3a',
            enabled: '#3a3a3a',
            focused: '#3a3a3a',
            hover: '#242424',
            pressed: '#030303',
          },
          outline: '#3a3a3a',
        },
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: '#3a3a3a',
            text: '#3a3a3a',
          },
          enabled: {
            icon: '#3a3a3a',
            text: '#3a3a3a',
          },
          focused: {
            icon: '#3a3a3a',
            text: '#3a3a3a',
          },
          hover: {
            icon: '#030303',
            text: '#242424',
          },
          outline: '#3a3a3a',
          pressed: {
            icon: '#030303',
            text: '#030303',
          },
        },
      },
      radius: '12px',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
  },
  toggleButton: {
    default: {
      color: {
        SLDS: {
          selected: {
            background: {
              disabled: 'rgba(4,93,103,0.48)',
              enabled: '#045d67',
              focus: '#00403a',
              hover: '#00403a',
              pressed: '#002623',
            },
            icon: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
          },
          unselected: {
            background: {
              disabled: 'rgba(4,93,103,0)',
              enabled: 'rgba(4,93,103,0)',
              focus: 'rgba(4,93,103,0.08)',
              hover: 'rgba(4,93,103,0.08)',
              pressed: 'rgba(4,93,103,0.16)',
            },
            border: {
              disabled: 'rgba(148,148,148,0.48)',
              enabled: '#949494',
              focus: '#696969',
              hover: '#00403a',
              pressed: '#002623',
            },
            icon: {
              disabled: 'rgba(87,87,87,0.48)',
              enabled: '#575757',
              focus: '#444444',
              hover: '#00403a',
              pressed: '#002623',
            },
          },
        },
        default: {
          background: {
            disabled: 'rgba(4,93,103,0)',
            enabled: 'rgba(4,93,103,0)',
            focus: 'rgba(4,93,103,0.08)',
            hover: 'rgba(4,93,103,0.08)',
            pressed: 'rgba(4,93,103,0.16)',
          },
          icon: {
            disabled: 'rgba(87,87,87,0.48)',
            enabled: '#575757',
            focus: '#444444',
            hover: '#444444',
            pressed: '#333333',
          },
        },
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    inverse: {
      color: {
        SLDS: {
          selected: {
            background: {
              disabled: 'rgba(4,93,103,0.48)',
              enabled: '#045d67',
              focus: '#00403a',
              hover: '#00403a',
              pressed: '#002623',
            },
            icon: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
          },
          unselected: {
            background: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              focus: 'rgba(255,255,255,0.08)',
              hover: 'rgba(255,255,255,0.08)',
              pressed: 'rgba(232,232,232,0.16)',
            },
            border: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#e8e8e8',
              pressed: '#dddddd',
            },
            icon: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#dddddd',
              pressed: '#e8e8e8',
            },
          },
        },
        default: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0.08)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(232,232,232,0.16)',
          },
          icon: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
  },
  tooltip: {
    default: {
      color: {
        background: '#242424',
        border: '#575757',
        default: {
          background: {
            primary: '#000000',
            secondary: '#ffffff',
          },
          border: {
            secondary: '#949494',
          },
          label: {
            subtitle: {
              primary: '#ffffff',
              secondary: '#3a3a3a',
            },
          },
        },
        text: '#ffffff',
        title: {
          background: {
            primary: '#000000',
            secondary: '#ffffff',
          },
          border: {
            secondary: '#949494',
          },
          label: {
            subtitle: {
              primary: '#ffffff',
              secondary: '#3a3a3a',
            },
            title: {
              primary: '#ffffff',
              secondary: '#3a3a3a',
            },
          },
        },
      },
      radius: {
        radius: '12px',
      },
      sizing: {
        default: {
          min: {
            height: '24px',
            width: '24px',
          },
        },
        max: '480px',
        min: '40px',
        title: {
          min: {
            height: '64px',
            width: '48px',
          },
        },
      },
      spacing: {
        Number: '0',
        default: {
          bottom: '0',
          left: '8px',
          padding: {
            bottom: '4px',
            side: '8px',
            top: '4px',
          },
          right: '8px',
          top: '0',
        },
        title: {
          bottom: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
    inverse: {
      color: {
        background: '#ffffff',
        border: '#e8e8e8',
        text: '#3a3a3a',
        title: {
          label: {
            subtitle: {
              primary: '#ffffff',
            },
            title: {
              primary: '#ffffff',
            },
          },
        },
      },
      radius: {
        radius: '12px',
      },
      sizing: {
        max: '480px',
        min: '40px',
      },
      spacing: {
        default: {
          padding: {
            bottom: '4px',
            side: '8px',
            top: '4px',
          },
        },
      },
    },
  },
  treeView: {
    default: {
      color: {
        richHeader: '#f5f8f6',
        selected: {
          background: {
            disabled: 'rgba(230,252,254,0.48)',
            enabled: '#e6fcfe',
            focus: '#e6fcfe',
            hover: '#cef8fd',
            pressed: '#a7f3fc',
          },
          border: {
            disabled: 'rgba(4,93,103,0.48)',
            enabled: '#045d67',
            focus: '#045d67',
            hover: '#00403a',
            pressed: '#002623',
          },
        },
        text: {
          subtitle: {
            disabled: 'rgba(87,87,87,0.48)',
            enabled: '#575757',
            focus: '#575757',
            hover: '#444444',
            pressed: '#333333',
          },
          title: {
            disabled: 'rgba(58,58,58,0.48)',
            enabled: '#3a3a3a',
            focus: '#3a3a3a',
            hover: '#242424',
            hyperlink: '#045d67',
            pressed: '#030303',
          },
        },
        unselected: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#edf2ef',
            pressed: '#e4ece7',
          },
          border: {
            enabled: '#e8e8e8',
          },
        },
      },
      padding: {
        small: {
          child: {
            bottom: '8px',
            gap: '8px',
            left: '48px',
            right: '24px',
            top: '8px',
          },
          parent: {
            bottom: '8px',
            gap: '8px',
            left: '16px',
            right: '24px',
            top: '8px',
          },
        },
        standard: {
          child: {
            bottom: '12px',
            gap: '8px',
            left: '52px',
            right: '24px',
            top: '12px',
          },
          parent: {
            bottom: '12px',
            gap: '8px',
            left: '16px',
            right: '24px',
            top: '12px',
          },
        },
      },
      radius: '0',
    },
  },
  typography: {
    default: {
      color: {
        default: {
          accent: '#00ccb6',
          brand: '#045d67',
          danger: '#bd0100',
          decorative1: '#004199',
          decorative2: '#995900',
          decorative3: '#8f9801',
          decorative4: '#004a66',
          decorative5: '#004d48',
          neutral: '#3a3a3a',
          success: '#027815',
          warning: '#926b00',
        },
        inverse: {
          accent: '#f0fffd',
          brand: '#e6fcfe',
          danger: '#fcebeb',
          decorative1: '#e5f0ff',
          decorative2: '#fff4e5',
          decorative3: '#fdffe6',
          decorative4: '#e5f8ff',
          decorative5: '#e5fffd',
          neutral: '#ffffff',
          success: '#e5ffea',
          warning: '#fbecc8',
        },
      },
      sizing: {
        icon: {
          lineHeight: {
            bodyDefault: '24px',
            bodySmall: '21px',
            caption: '20px',
            headline: '53px',
            subheadline: '35px',
            subtitle: '30px',
            title: '36px',
          },
        },
      },
      spacing: {
        gap: {
          bodyDefault: '8px',
          bodySmall: '4px',
          caption: '4px',
          headline: '12px',
          subheadline: '8px',
          subtitle: '8px',
          title: '8px',
        },
      },
    },
    font: {
      fallback: 'Poppins, Noto Sans, Nunito Sans, Arial, sans-serif',
      family: 'Poppins',
      size: {
        '2x': '24px',
        '3x': '28px',
        '4x': '32px',
        '5x': '36px',
        '6x': '40px',
        '7x': '48px',
        '8x': '60px',
        base: '16px',
        lg: '18px',
        sm: '14px',
        xl: '20px',
        xs: '13px',
      },
      weight: {
        black: 900,
        bold: 700,
        heavy: 800,
        light: 300,
        medium: 500,
        regular: 400,
        semibold: 600,
        thin: 200,
      },
    },
    lineHeight: {
      '2x': '35px',
      '3x': '36px',
      '4x': '42px',
      '5x': '48px',
      '6x': '53px',
      '7x': '60px',
      '8x': '72px',
      base: '24px',
      lg: '27px',
      sm: '21px',
      xl: '30px',
      xs: '20px',
    },
    spacing: {
      letter: {
        '2x': '0.48px',
        '3x': '0.80px',
        '4x': '1.00px',
        '5x': '1.20px',
        '6x': '1.40px',
        base: '0.32px',
        lg: '0.32px',
        md: '0.28px',
        negative: {
          lg: '-0.48px',
          md: '-0.32px',
          sm: '-0.26px',
          xl: '-1.00px',
        },
        none: '0',
        sm: '0.26px',
        xl: '0.40px',
      },
      paragraph: {
        '2x': '52.80px',
        '3x': '54.00px',
        '4x': '63.00px',
        '5x': '72.00px',
        '6x': '79.20px',
        '7x': '90.00px',
        '8x': '108.00px',
        base: '36.00px',
        lg: '40.50px',
        none: '0',
        sm: '31.50px',
        xl: '45.00px',
        xs: '29.25px',
      },
    },
  },
  videoPlayer: {
    default: {
      radius: {
        container: '0',
        focus: '0',
      },
    },
  },
};
